// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23f44700%27 stroke-width=%273%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%2720 6 9 17 4 12%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.2.2 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --spacing: 0.25rem;
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    -moz-tab-size: 4;
      -o-tab-size: 4;
         tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::-moz-placeholder {
    opacity: 1;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::-moz-placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    -webkit-appearance: button;
       -moz-appearance: button;
            appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border-width: 0;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .static {
    position: static;
  }
  .start {
    inset-inline-start: var(--spacing);
  }
  .container {
    width: 100%;
    @media (width >= 40rem) {
      max-width: 40rem;
    }
    @media (width >= 48rem) {
      max-width: 48rem;
    }
    @media (width >= 64rem) {
      max-width: 64rem;
    }
    @media (width >= 80rem) {
      max-width: 80rem;
    }
    @media (width >= 96rem) {
      max-width: 96rem;
    }
  }
  .block {
    display: block;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .table {
    display: table;
  }
  .transform {
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
  }
}
:root {
  color-scheme: light;
  --bg: #ece2bd;
  --bg-soft: #f1e8ca;
  --surface: #f6efd6;
  --ink: #18140d;
  --muted: rgba(24, 20, 13, 0.62);
  --dark: #141009;
  --accent: #f44700;
  --accent-2: #ffc240;
  --line: rgba(24, 20, 13, 0.14);
  --line-strong: rgba(24, 20, 13, 0.26);
  --container: 1240px;
  --radius: 0;
}
* {
  box-sizing: border-box;
}
html {
  scroll-behavior: smooth;
}
html,
body,
#root {
  height: 100%;
  margin: 0;
}
body {
  margin: 0;
  font-family: "Manrope", "Segoe UI", sans-serif;
  font-size: 17px;
  color: var(--ink);
  background: var(--bg);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
}
img {
  max-width: 100%;
}
a {
  color: inherit;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.container {
  width: 100%;
  max-width: var(--container);
  margin: 0 auto;
  padding: 0 clamp(20px, 5vw, 48px);
}
.hero-title,
.page-title,
.section-title,
.wizard-headline,
.event-title,
.case-title,
.cta-band h2 {
  font-family: "Manrope", sans-serif;
  font-weight: 800;
  letter-spacing: -0.025em;
  line-height: 1.03;
  margin: 0;
}
.kicker {
  margin: 0 0 22px;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: var(--accent);
}
.site {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  overflow-x: clip;
}
.site-main {
  flex: 1 1 auto;
}
.site-banner {
  position: relative;
  background: var(--dark);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 9px clamp(44px, 7vw, 60px);
  font-size: 0.9rem;
}
.site-banner-link {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6px 12px;
  color: inherit;
  text-decoration: none;
}
.site-banner-tag {
  font-size: 0.6rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.09em;
  color: var(--dark);
  background: var(--accent-2);
  padding: 2px 6px;
  border-radius: 3px;
}
.site-banner-text {
  font-weight: 600;
}
.site-banner-cta {
  font-weight: 700;
  color: var(--accent-2);
  white-space: nowrap;
}
.site-banner-link:hover .site-banner-cta {
  text-decoration: underline;
}
.site-banner-close {
  position: absolute;
  right: clamp(10px, 3vw, 18px);
  top: 50%;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  color: rgba(255, 255, 255, 0.65);
  font-size: 1.3rem;
  line-height: 1;
  cursor: pointer;
  padding: 4px 8px;
}
.site-banner-close:hover {
  color: #fff;
}
.site-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: var(--bg);
  @supports (color: color-mix(in lab, red, red)) {
    background: color-mix(in srgb, var(--bg) 88%, transparent);
  }
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--line);
}
.site-header-inner {
  max-width: var(--container);
  margin: 0 auto;
  padding: 16px clamp(20px, 5vw, 48px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}
.site-brand {
  display: inline-flex;
  align-items: center;
  gap: clamp(10px, 1.5vw, 16px);
  text-decoration: none;
}
.site-brand img {
  height: clamp(38px, 4.5vw, 52px);
  width: auto;
}
.site-brand-partner {
  padding-left: clamp(10px, 1.5vw, 16px);
  border-left: 1px solid var(--line-strong);
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  white-space: nowrap;
  color: var(--ink);
}
.hero-partner-badge {
  position: absolute;
  right: clamp(20px, 5vw, 48px);
  bottom: clamp(24px, 4vw, 52px);
  z-index: 2;
  height: clamp(104px, 12vw, 148px);
  width: auto;
  filter: drop-shadow(0 8px 22px rgba(0, 0, 0, 0.45));
}
.site-nav {
  display: flex;
  align-items: center;
  gap: clamp(14px, 2vw, 32px);
}
.site-nav-link {
  font-weight: 600;
  font-size: 0.98rem;
  text-decoration: none;
  color: var(--ink);
  opacity: 0.7;
  transition: opacity 160ms ease;
}
.site-nav-link:hover,
.site-nav-link.is-active {
  opacity: 1;
}
.site-nav-link.is-active {
  color: var(--accent);
}
.nav-cta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0.6rem 1.2rem;
  background: var(--ink);
  color: var(--bg);
  font-weight: 700;
  font-size: 0.95rem;
  text-decoration: none;
  border-radius: 0;
  transition: background 160ms ease, transform 160ms ease;
}
.nav-cta:hover {
  background: var(--accent);
  color: #fff;
  transform: translateY(-1px);
}
.nav-toggle {
  display: none;
  width: 44px;
  height: 40px;
  background: transparent;
  border: 1px solid var(--line-strong);
  border-radius: 0;
  cursor: pointer;
  position: relative;
}
.nav-toggle-bars,
.nav-toggle-bars::before,
.nav-toggle-bars::after {
  position: absolute;
  left: 50%;
  width: 20px;
  height: 2px;
  background: var(--ink);
  transform: translateX(-50%);
  content: "";
  border-radius: 2px;
}
.nav-toggle-bars {
  top: 50%;
  transform: translate(-50%, -50%);
}
.nav-toggle-bars::before {
  top: -6px;
}
.nav-toggle-bars::after {
  top: 6px;
}
.hero {
  position: relative;
  overflow: hidden;
  background: var(--dark);
}
.hero-inner {
  position: relative;
  z-index: 1;
  max-width: var(--container);
  margin: 0 auto;
  padding-inline: clamp(20px, 5vw, 48px);
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  min-height: min(86vh, 760px);
}
.hero-copy {
  padding: clamp(48px, 8vw, 96px) 0;
  max-width: 600px;
  color: #fff;
}
.hero-copy .hero-lead {
  color: rgba(255, 255, 255, 0.82);
}
.hero-copy .link-button-arrow {
  color: #fff;
}
.hero-copy .link-button-arrow:hover {
  color: var(--accent-2);
}
.hero-title {
  font-size: clamp(2.9rem, 7vw, 5.4rem);
}
.hero-lead {
  margin: clamp(22px, 3vw, 30px) 0 0;
  max-width: 48ch;
  font-size: clamp(1.05rem, 1.4vw, 1.3rem);
  color: var(--muted);
}
.hero-cta-row {
  margin-top: clamp(30px, 4vw, 44px);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 18px 30px;
}
.hero-visual {
  position: absolute;
  inset: 0;
  z-index: 0;
}
.hero-visual > img:not(.hero-partner-badge) {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  -o-object-position: center;
     object-position: center;
}
.hero-visual::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    rgba(10, 8, 4, 0.92) 0%,
    rgba(10, 8, 4, 0.78) 28%,
    rgba(10, 8, 4, 0.5) 52%,
    rgba(10, 8, 4, 0.12) 78%,
    transparent 100%
  );
}
.page-hero {
  padding: clamp(56px, 9vw, 130px) 0 clamp(36px, 5vw, 64px);
}
.page-title {
  font-size: clamp(2.4rem, 5.5vw, 4.4rem);
}
.page-lead {
  margin: clamp(20px, 2.5vw, 28px) 0 0;
  max-width: 60ch;
  font-size: clamp(1.05rem, 1.4vw, 1.28rem);
  color: var(--muted);
}
.section {
  padding: clamp(56px, 9vw, 130px) 0;
}
.section-alt {
  background: var(--bg-soft);
}
.section-dark {
  background: var(--dark);
  color: #fff;
}
.section-dark .section-title {
  color: #fff;
}
.section-dark .principle-card {
  border-top-color: rgba(255, 255, 255, 0.85);
}
.section-dark .principle-card h3 {
  color: #fff;
}
.section-dark .principle-card p {
  color: rgba(255, 255, 255, 0.7);
}
.section-dark .link-button-arrow {
  color: #fff;
}
.section-head {
  max-width: 62ch;
  margin-bottom: clamp(34px, 5vw, 60px);
}
.section-title {
  font-size: clamp(2rem, 4vw, 3.2rem);
}
.section-intro {
  margin: 20px 0 0;
  font-size: clamp(1.05rem, 1.3vw, 1.2rem);
  color: var(--muted);
}
.section-foot {
  margin-top: clamp(34px, 5vw, 52px);
}
.cta-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 0;
  padding: 0.95rem 1.9rem;
  font-family: inherit;
  font-size: 1.02rem;
  font-weight: 700;
  text-decoration: none;
  color: #fff;
  background: var(--accent);
  transition: transform 180ms ease, box-shadow 180ms ease, background 180ms ease;
  box-shadow: 0 12px 26px rgba(244, 71, 0, 0.26);
  cursor: pointer;
}
.cta-button:hover,
.cta-button:focus-visible {
  transform: translateY(-2px);
  box-shadow: 0 16px 32px rgba(244, 71, 0, 0.32);
}
.cta-button-light {
  background: var(--ink);
  color: var(--bg);
  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.2);
}
.cta-button-light:hover {
  background: #000;
}
.cta-button-outline {
  background: transparent;
  color: #fff;
  box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.55);
}
.cta-button-outline:hover {
  background: rgba(255, 255, 255, 0.1);
  box-shadow: inset 0 0 0 2px #fff;
}
.link-button {
  background: none;
  border: none;
  padding: 6px 0;
  font: inherit;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 5px;
  text-decoration-thickness: 2px;
  text-decoration-color: var(--accent);
  color: var(--ink);
  cursor: pointer;
}
.link-button-arrow,
.inline-link {
  font-weight: 700;
  text-decoration: none;
  color: var(--ink);
  border-bottom: 2px solid var(--accent);
  padding-bottom: 3px;
  transition: color 160ms ease;
}
.link-button-arrow:hover {
  color: var(--accent);
}
.inline-link {
  border-bottom-width: 1px;
}
.strip-stats {
  background: var(--accent);
  color: #fff;
  padding: clamp(48px, 7vw, 90px) 0;
}
.stat-block {
  display: grid;
  gap: clamp(24px, 4vw, 56px);
}
.stat-block-3 {
  grid-template-columns: repeat(3, 1fr);
}
.strip-stats .stat-eyebrow {
  display: block;
  margin-bottom: 10px;
  font-size: 0.74rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: rgba(255, 255, 255, 0.85);
}
.strip-stats .stat-value {
  color: #fff;
  font-variant-numeric: tabular-nums;
}
.strip-stats .stat-label {
  color: rgba(255, 255, 255, 0.9);
}
.stat-value {
  display: block;
  font-weight: 800;
  letter-spacing: -0.03em;
  font-size: clamp(2.2rem, 4.5vw, 3.4rem);
  line-height: 1;
  color: var(--accent);
}
.stat-label {
  display: block;
  margin-top: 12px;
  font-size: 0.96rem;
  line-height: 1.45;
  color: var(--muted);
}
.card-grid {
  display: grid;
  gap: clamp(18px, 2.4vw, 28px);
}
.card-grid-3 {
  grid-template-columns: repeat(3, 1fr);
}
.card-grid-4 {
  grid-template-columns: repeat(4, 1fr);
}
.teaser-card,
.principle-card,
.role-card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: clamp(22px, 2.6vw, 32px);
}
.teaser-card {
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
  text-decoration: none;
  color: var(--ink);
  transition: transform 200ms ease, box-shadow 200ms ease,
    border-color 200ms ease;
}
.teaser-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 40px rgba(24, 20, 13, 0.1);
  border-color: var(--line-strong);
}
.teaser-media {
  position: relative;
  aspect-ratio: 16 / 10;
  overflow: hidden;
}
.teaser-media img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  display: block;
  transition: transform 400ms ease;
}
.teaser-card:hover .teaser-media img {
  transform: scale(1.04);
}
.teaser-media .status-pill {
  position: absolute;
  top: 14px;
  left: 14px;
  background: rgba(20, 16, 9, 0.7);
  color: #fff;
  backdrop-filter: blur(4px);
}
.teaser-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  padding: clamp(20px, 2.4vw, 28px);
}
.teaser-label {
  font-size: 0.76rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--accent);
}
.teaser-card h3,
.principle-card h3,
.role-card h3 {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 800;
  letter-spacing: -0.02em;
}
.teaser-card p,
.principle-card p,
.role-card p {
  margin: 0;
  font-size: 1rem;
  color: var(--muted);
}
.teaser-link {
  margin-top: auto;
  padding-top: 6px;
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--accent);
}
.principle-card {
  background: transparent;
  border: none;
  border-top: 2px solid var(--ink);
  border-radius: 0;
  padding: 24px 0 0;
}
.role-card {
  background: transparent;
  border: none;
  border-top: 2px solid var(--ink);
  border-radius: 0;
  padding: 22px 0 0;
}
.role-focus {
  display: block;
  font-weight: 700;
  font-size: 0.78rem;
  line-height: 1.2;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--accent);
  margin-bottom: 14px;
}
.status-pill {
  display: inline-block;
  padding: 5px 13px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  border-radius: 0;
}
.status-ongoing,
.status-upcoming {
  background: rgba(244, 71, 0, 0.14);
  color: var(--accent);
}
.status-delivered,
.status-past {
  background: rgba(24, 20, 13, 0.1);
  color: var(--ink);
}
.tag-list {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 14px 0 0;
  padding: 0;
}
.tag {
  padding: 4px 12px;
  font-size: 0.8rem;
  font-weight: 600;
  border: 1px solid var(--line);
  border-radius: 0;
  color: var(--muted);
}
.case-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: clamp(20px, 2.5vw, 32px);
}
@media (max-width: 820px) {
  .case-list {
    grid-template-columns: 1fr;
  }
}
.case-card {
  scroll-margin-top: 110px;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.case-cover {
  position: relative;
  aspect-ratio: 4 / 3;
  overflow: hidden;
}
.case-brand {
  position: absolute;
  left: clamp(16px, 2vw, 22px);
  bottom: clamp(16px, 2vw, 22px);
  background: var(--ink);
  color: #fff;
  padding: 9px 18px;
  font-size: 0.95rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.case-cover img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  display: block;
  transition: transform 0.5s ease;
}
.case-card:hover .case-cover img {
  transform: scale(1.03);
}
.case-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: clamp(24px, 3vw, 38px);
}
.case-title-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.case-title {
  font-size: clamp(1.5rem, 2.6vw, 2.1rem);
  line-height: 1.1;
}
.case-summary {
  margin: 16px 0 0;
  font-size: clamp(1.02rem, 1.3vw, 1.18rem);
  font-weight: 600;
}
.case-details {
  margin-top: 16px;
}
.case-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--accent);
  list-style: none;
}
.case-toggle::-webkit-details-marker {
  display: none;
}
.case-toggle::after {
  content: "+";
  font-size: 1.2em;
  line-height: 1;
}
.case-details[open] .case-toggle::after {
  content: "–";
}
.case-toggle-less {
  display: none;
}
.case-details[open] .case-toggle-more {
  display: none;
}
.case-details[open] .case-toggle-less {
  display: inline;
}
.case-body {
  margin-top: 14px;
  display: grid;
  gap: 12px;
  color: var(--muted);
}
.case-body p {
  margin: 0;
}
.case-tags {
  margin-top: auto;
  padding-top: clamp(20px, 3vw, 28px);
}
.case-card .stat-block {
  grid-template-columns: repeat(4, 1fr);
  margin-top: clamp(26px, 3vw, 38px);
  padding-top: clamp(24px, 3vw, 34px);
  border-top: 1px solid var(--line);
}
.case-footnote {
  margin: 22px 0 0;
  font-size: 0.92rem;
  color: var(--muted);
}
.layer-stack {
  display: grid;
  gap: 12px;
}
.layer {
  border-radius: var(--radius);
  padding: clamp(20px, 2.6vw, 30px);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: clamp(18px, 2.5vw, 30px);
}
.layer-text {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.layer-icon {
  flex: none;
  width: clamp(34px, 4vw, 46px);
  height: clamp(34px, 4vw, 46px);
  color: var(--ink);
  opacity: 0.55;
}
.layer-3 .layer-icon {
  color: #f6efd6;
  opacity: 0.75;
}
.layer-0 {
  background: #f2802f;
}
.layer-0 .layer-detail {
  color: rgba(24, 20, 13, 0.78);
}
.layer-1 {
  background: #e4c4a4;
}
.layer-2 {
  background: #cda27d;
}
.layer-3 {
  background: #6e472a;
}
.layer-3 .layer-name {
  color: #f6efd6;
}
.layer-3 .layer-detail {
  color: rgba(255, 255, 255, 0.72);
}
.layer-name {
  font-weight: 800;
  letter-spacing: -0.02em;
  font-size: clamp(1.1rem, 2vw, 1.45rem);
}
.layer-detail {
  font-size: 0.98rem;
  color: var(--muted);
}
.rollout-track {
  display: grid;
  gap: 12px;
}
.rollout-row {
  display: block;
  width: 100%;
}
.rollout-bar {
  border-radius: var(--radius);
  padding: clamp(16px, 2vw, 24px);
  display: flex;
  align-items: center;
  gap: clamp(16px, 2.2vw, 26px);
}
.rollout-icon {
  flex: none;
  width: clamp(30px, 3.4vw, 40px);
  height: clamp(30px, 3.4vw, 40px);
  color: var(--ink);
  opacity: 0.55;
}
.rollout-text {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.rollout-name {
  font-weight: 800;
  color: var(--ink);
}
.rollout-detail {
  font-size: 0.95rem;
  color: var(--muted);
}
.rollout-now {
  flex: none;
  background: var(--ink);
  color: var(--bg);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 3px 9px;
}
.rollout-0 {
  background: #f2802f;
}
.rollout-1 {
  background: #e4c4a4;
}
.rollout-2 {
  background: #cda27d;
}
.rollout-3 {
  background: #6e472a;
}
.rollout-3 .rollout-name {
  color: #f6efd6;
}
.rollout-3 .rollout-detail {
  color: rgba(255, 255, 255, 0.72);
}
.rollout-3 .rollout-icon {
  color: #f6efd6;
  opacity: 0.75;
}
.rollout-axis {
  position: relative;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid var(--line-strong);
  height: 2.4em;
}
.rollout-tick {
  position: absolute;
  top: 12px;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--muted);
  white-space: nowrap;
  transform: translateX(-50%);
}
.rollout-tick::before {
  content: "";
  position: absolute;
  top: -13px;
  left: 50%;
  width: 1px;
  height: 8px;
  background: var(--line-strong);
}
.rollout-axis .rollout-tick:first-child {
  transform: translateX(0);
}
.rollout-axis .rollout-tick:first-child::before {
  left: 0;
}
.rollout-axis .rollout-tick:last-child {
  transform: translateX(-100%);
}
.rollout-axis .rollout-tick:last-child::before {
  left: auto;
  right: 0;
}
@media (max-width: 640px) {
  .rollout-bar {
    margin-inline-start: 0 !important;
  }
  .rollout-axis {
    display: none;
  }
}
.step-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: clamp(18px, 2.6vw, 30px);
}
.step {
  display: flex;
  gap: 22px;
  align-items: flex-start;
}
.step-num {
  flex: none;
  width: 48px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(244, 71, 0, 0.12);
  color: var(--accent);
  border-radius: 50%;
  font-weight: 800;
  font-size: 1.15rem;
}
.step h3 {
  margin: 8px 0 6px;
  font-size: 1.3rem;
  font-weight: 800;
  letter-spacing: -0.02em;
}
.step p {
  margin: 0;
  max-width: 70ch;
  color: var(--muted);
}
.event-list {
  display: grid;
  gap: clamp(22px, 3vw, 40px);
}
.event-card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: clamp(26px, 4vw, 52px);
  scroll-margin-top: 100px;
}
.event-card-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
}
.event-date {
  font-weight: 700;
  color: var(--muted);
}
.event-title {
  font-size: clamp(1.7rem, 3.6vw, 2.8rem);
}
.event-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 48px;
  margin: 22px 0;
}
.event-meta dt {
  font-size: 0.74rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--accent);
}
.event-meta dd {
  margin: 4px 0 0;
  font-weight: 600;
}
.event-description {
  margin: 0 0 22px;
  max-width: 72ch;
  font-size: 1.1rem;
  color: var(--muted);
}
.event-highlights {
  list-style: none;
  margin: 0 0 26px;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
}
.event-highlights li {
  border-top: 2px solid var(--ink);
  padding: 14px 0 0;
}
.event-highlights h3 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 800;
}
.event-highlights p {
  margin: 6px 0 0;
  font-size: 0.96rem;
  color: var(--muted);
}
.event-gallery {
  margin-top: 10px;
}
.marquee {
  width: 100%;
  overflow: hidden;
  -webkit-mask-image: linear-gradient(
    90deg,
    transparent 0,
    #000 8%,
    #000 92%,
    transparent 100%
  );
  mask-image: linear-gradient(
    90deg,
    transparent 0,
    #000 8%,
    #000 92%,
    transparent 100%
  );
}
.marquee-track {
  display: flex;
  width: -moz-max-content;
  width: max-content;
  animation: marquee-scroll 70s linear infinite;
}
.marquee-track.is-reverse {
  animation-direction: reverse;
}
.marquee:hover .marquee-track {
  animation-play-state: paused;
}
.marquee-item {
  flex: none;
  height: clamp(190px, 24vw, 300px);
  margin-right: 16px;
}
.marquee-item img {
  height: 100%;
  width: auto;
  display: block;
  -o-object-fit: cover;
     object-fit: cover;
  border-radius: 0;
}
@keyframes marquee-scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}
@media (prefers-reduced-motion: reduce) {
  .marquee-track {
    animation: none;
  }
  .marquee {
    overflow-x: auto;
  }
}
.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 12px;
}
.gallery-card {
  margin: 0;
  overflow: hidden;
  border-radius: 0;
  aspect-ratio: 4 / 3;
}
.gallery-button {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  border: none;
  background: transparent;
  cursor: zoom-in;
}
.gallery-photo {
  width: 100%;
  height: 100%;
  display: block;
  -o-object-fit: cover;
     object-fit: cover;
  transition: transform 360ms ease;
}
.gallery-card:hover .gallery-photo {
  transform: scale(1.05);
}
.lightbox {
  position: fixed;
  inset: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(12px, 3vw, 36px);
  background: rgba(0, 0, 0, 0.86);
}
.lightbox-content {
  position: relative;
  width: min(96vw, 1200px);
  max-height: 92vh;
}
.lightbox-image {
  display: block;
  width: 100%;
  max-height: 92vh;
  -o-object-fit: contain;
     object-fit: contain;
  border-radius: 0;
}
.lightbox-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 42px;
  height: 42px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 1.3rem;
  line-height: 1;
  cursor: pointer;
}
.lightbox-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 46px;
  height: 46px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 1.3rem;
  line-height: 1;
  cursor: pointer;
}
.lightbox-nav-prev {
  left: 12px;
}
.lightbox-nav-next {
  right: 12px;
}
.wizard-wrap {
  max-width: 780px;
}
.wizard {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: clamp(28px, 4vw, 52px);
}
.wizard-progress {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
}
.wizard-dot {
  width: 100%;
  height: 6px;
  border-radius: 0;
  background: rgba(24, 20, 13, 0.12);
}
.wizard-dot.is-filled {
  background: var(--accent);
}
.wizard-step-label {
  margin: 0 0 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 0.78rem;
  color: var(--accent);
}
.wizard-question {
  margin: 0 0 26px;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-size: clamp(1.5rem, 3vw, 2.3rem);
  line-height: 1.08;
}
.wizard-options {
  display: grid;
  gap: 12px;
  margin-bottom: 20px;
}
.wizard-option {
  text-align: left;
  padding: 1.1rem 1.3rem;
  background: var(--bg);
  border: 1px solid var(--line);
  border-radius: 0;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 140ms ease, background 140ms ease,
    transform 140ms ease;
}
.wizard-option:hover,
.wizard-option.is-selected {
  background: rgba(244, 71, 0, 0.08);
  border-color: var(--accent);
  transform: translateX(4px);
}
.wizard-headline {
  font-size: clamp(1.9rem, 4vw, 2.9rem);
  margin: 8px 0 18px;
}
.wizard-body {
  font-size: 1.12rem;
  margin: 0 0 26px;
  color: var(--muted);
}
.wizard-related {
  border-top: 1px solid var(--line);
  padding-top: 22px;
  margin-bottom: 28px;
}
.wizard-related-title {
  display: block;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 0.78rem;
  color: var(--accent);
  margin-bottom: 12px;
}
.wizard-related ul {
  margin: 0;
  padding-left: 18px;
  display: grid;
  gap: 10px;
  color: var(--muted);
}
.wizard-related a {
  font-weight: 700;
  color: var(--ink);
}
.wizard-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}
.split-layout {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: clamp(32px, 5vw, 72px);
  align-items: start;
}
.check-list {
  list-style: none;
  margin: 22px 0 0;
  padding: 0;
  display: grid;
  gap: 16px;
}
.check-list li {
  position: relative;
  padding-left: 38px;
  font-size: 1.08rem;
}
.check-list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 3px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(244, 71, 0, 0.14);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
}
.gate-card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: clamp(26px, 3vw, 36px);
  position: sticky;
  top: 110px;
}
.gate-card h2 {
  margin: 0 0 8px;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-size: 1.5rem;
}
.gate-success h3 {
  font-weight: 800;
  margin: 6px 0 18px;
}
.gate-fallback,
.gate-success {
  display: grid;
  gap: 16px;
  justify-items: flex-start;
}
.contact-section {
  padding-top: clamp(56px, 9vw, 120px);
}
.contact-layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: clamp(28px, 5vw, 48px);
  align-items: start;
  max-width: 780px;
  margin-inline: auto;
}
.contact-intro .page-title {
  margin-top: 8px;
}
.quote-card {
  margin: clamp(28px, 4vw, 40px) 0;
  background: var(--dark);
  color: var(--bg);
  border-radius: var(--radius);
  padding: clamp(26px, 3vw, 38px);
}
.quote-card blockquote {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 500;
  line-height: 1.55;
}
.quote-card figcaption {
  margin-top: 18px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.82rem;
  color: var(--accent-2);
}
.contact-direct {
  display: grid;
  gap: 10px;
}
.contact-direct a {
  font-weight: 700;
  color: var(--ink);
  text-decoration: none;
  border-bottom: 2px solid var(--accent);
  width: -moz-fit-content;
  width: fit-content;
  padding-bottom: 2px;
}
.contact-form-panel {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: clamp(26px, 3.5vw, 44px);
}
.contact-block + .contact-block {
  margin-top: clamp(28px, 4vw, 44px);
  padding-top: clamp(28px, 4vw, 44px);
  border-top: 1px solid var(--line);
}
.contact-block-title {
  margin: 0 0 6px;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--ink);
}
.contact-block-lead {
  margin: 0 0 16px;
  color: var(--muted);
}
.booking-confirmed {
  max-width: 640px;
  margin-inline: auto;
  text-align: center;
}
.booking-confirmed .hero-cta-row {
  justify-content: center;
}
.booking-confirmed-note {
  margin-top: clamp(28px, 4vw, 40px);
  color: var(--muted);
  font-size: 0.95rem;
}
.booking-confirmed-note a {
  font-weight: 700;
  color: var(--ink);
  border-bottom: 2px solid var(--accent);
  text-decoration: none;
}
.registration-form-shell,
.registration-fallback {
  margin-top: 4px;
}
.registration-fallback {
  display: grid;
  gap: 14px;
  justify-items: flex-start;
}
.hubspot-form-target {
  min-height: 120px;
}
.hubspot-form-target iframe {
  display: block;
  width: 100%;
  border: 0;
}
.cta-band {
  padding: clamp(20px, 4vw, 40px) 0 clamp(64px, 9vw, 130px);
}
.cta-band-inner {
  background: var(--dark);
  color: var(--bg);
  border-radius: 0;
  padding: clamp(36px, 5vw, 72px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 28px;
}
.cta-band h2 {
  margin: 0 0 10px;
  font-size: clamp(1.7rem, 3.4vw, 2.7rem);
  color: var(--bg);
}
.cta-band p {
  margin: 0;
  max-width: 52ch;
  color: rgba(255, 255, 255, 0.72);
}
.empty-state {
  border: 1px dashed var(--line-strong);
  border-radius: var(--radius);
  padding: clamp(26px, 4vw, 44px);
  background: var(--bg-soft);
  font-size: 1.08rem;
  color: var(--muted);
}
.empty-state p {
  margin: 0;
}
.site-footer {
  background: var(--dark);
  color: var(--bg);
  margin-top: auto;
}
.site-footer-inner {
  max-width: var(--container);
  margin: 0 auto;
  padding: clamp(48px, 6vw, 84px) clamp(20px, 5vw, 48px);
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: clamp(32px, 5vw, 72px);
}
.footer-kicker {
  margin: 0 0 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: var(--accent-2);
  font-size: 0.95rem;
}
.footer-tag {
  margin: 0;
  max-width: 46ch;
  color: rgba(255, 255, 255, 0.7);
}
.footer-cols {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 28px;
}
.footer-col {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.footer-contact-person {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.footer-phone {
  color: var(--accent-2);
}
.footer-col-title {
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.78rem;
  color: var(--accent-2);
}
.footer-link {
  color: rgba(255, 255, 255, 0.78);
  text-decoration: none;
  font-size: 0.96rem;
}
.footer-link:hover {
  color: #fff;
}
.footer-base {
  max-width: var(--container);
  margin: 0 auto;
  padding: 22px clamp(20px, 5vw, 48px);
  border-top: 1px solid rgba(255, 255, 255, 0.14);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px;
  font-size: 0.82rem;
  color: rgba(255, 255, 255, 0.5);
}
.footer-base-link {
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
}
.footer-base-link:hover {
  color: #fff;
}
.legal-content {
  max-width: 760px;
}
.legal-updated {
  margin: 0 0 clamp(24px, 4vw, 36px);
  font-size: 0.9rem;
  color: var(--muted);
}
.legal-content h2 {
  margin: clamp(32px, 4vw, 44px) 0 12px;
  font-size: clamp(1.3rem, 2.2vw, 1.6rem);
  font-weight: 800;
  letter-spacing: -0.02em;
}
.legal-content p,
.legal-content li {
  color: var(--ink);
  line-height: 1.7;
}
.legal-content ul {
  margin: 0 0 4px;
  padding-left: 22px;
  display: grid;
  gap: 8px;
}
.legal-content a {
  font-weight: 600;
  color: var(--ink);
  text-decoration: underline;
  text-decoration-color: var(--accent);
  text-underline-offset: 2px;
}
@keyframes rise-up {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.hero-copy,
.page-hero > .container {
  animation: rise-up 650ms cubic-bezier(0.2, 0.75, 0.3, 1) both;
}
@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }
  .hero-copy,
  .page-hero > .container {
    animation: none;
  }
}
@media (max-width: 1000px) {
  .nav-toggle {
    display: block;
  }
  .site-nav {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    background: var(--bg);
    border-bottom: 1px solid var(--line);
    padding: 8px clamp(20px, 5vw, 48px) 20px;
    display: none;
  }
  .site-nav.is-open {
    display: flex;
  }
  .site-nav-link {
    padding: 14px 0;
    border-bottom: 1px solid var(--line);
    opacity: 1;
  }
  .nav-cta {
    margin-top: 14px;
    justify-content: center;
  }
  .hero-inner {
    grid-template-columns: 1fr;
    padding-right: clamp(20px, 5vw, 48px);
    min-height: 0;
    gap: 0;
  }
  .hero-copy {
    max-width: none;
    padding: clamp(40px, 8vw, 72px) 0 clamp(28px, 5vw, 40px);
  }
  .hero-partner-badge {
    position: static;
    height: clamp(88px, 24vw, 124px);
    margin: 0 0 clamp(36px, 8vw, 56px);
  }
  .hero-visual::after {
    background: linear-gradient(
      180deg,
      rgba(10, 8, 4, 0.7) 0%,
      rgba(10, 8, 4, 0.78) 100%
    );
  }
  .card-grid-3,
  .card-grid-4,
  .stat-block-3 {
    grid-template-columns: repeat(2, 1fr);
  }
  .split-layout,
  .contact-layout,
  .site-footer-inner {
    grid-template-columns: 1fr;
  }
  .gate-card {
    position: static;
  }
  .case-card .stat-block {
    grid-template-columns: repeat(2, 1fr);
  }
  .event-highlights {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 560px) {
  .site-brand-partner {
    padding-left: 10px;
    font-size: 0.66rem;
    letter-spacing: 0.06em;
  }
  .card-grid-3,
  .card-grid-4,
  .stat-block-3,
  .case-card .stat-block {
    grid-template-columns: 1fr;
  }
  .hero-cta-row .cta-button,
  .cta-band .cta-button {
    width: 100%;
  }
  .gallery-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .cta-band-inner {
    flex-direction: column;
    align-items: flex-start;
  }
  .contact-form-panel {
    padding: 20px 16px;
  }
  .hubspot-form-target :is(form, .hs-form) {
    grid-template-columns: 1fr;
  }
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./node_modules/tailwindcss/index.css","webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA,iEAAA;AC86BE,iBAAmB;AA96BrB,yCAAyC;AAEzC;EACE;IACE;6DAEyD;IAEzD;8BAE0B;IA6T1B,kBAAkB;IA+KlB,uCAAoD;IASpD,4CAAyD;EA5f5C;AADJ;AAmhBb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,gBAAW;MAAX,cAAW;SAAX,WAAW;IACX,2JASC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EAtBpC;EA+BN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IACE,yCAAyC;IACzC,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IACd,gCAAgC;IAChC,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADC;EAQhB;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EAAd;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;IAAd;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,cAAc;EADoB;EAQpC;IACE,gBAAgB;EADD;EAQjB;IAGE,0BAAkB;OAAlB,uBAAkB;YAAlB,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AAnZnC;AAwZZ;EACE;IAAA,kBAAmB;IAAnB,UAAmB;IAAnB,WAAmB;IAAnB,UAAmB;IAAnB,YAAmB;IAAnB,gBAAmB;IAAnB,qBAAmB;IAAnB,mBAAmB;IAAnB,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,kCAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,0GAAmB;EAAA;AADJ;AC16BjB;EACE,mBAAoB;EACpB,aAAc;EACd,kBAAmB;EACnB,kBAAmB;EACnB,cAAe;EACf,+BAAgC;EAChC,eAAgB;EAChB,iBAAkB;EAClB,mBAAoB;EACpB,8BAA+B;EAC/B,qCAAsC;EACtC,mBAAoB;EACpB,WAAY;AACb;AAED;EACE,sBAAuB;AACxB;AAED;EACE,uBAAwB;AACzB;AAED;;;EAGE,YAAa;EACb,SAAU;AACX;AAED;EACE,SAAU;EACV,8CAA+C;EAC/C,eAAgB;EAChB,iBAAkB;EAClB,qBAAsB;EACtB,gBAAiB;EACjB,mCAAoC;AACrC;AAED;EACE,eAAgB;AACjB;AAED;EACE,cAAe;AAChB;AAED;EACE,kBAAmB;EACnB,UAAW;EACX,WAAY;EACZ,UAAW;EACX,YAAa;EACb,gBAAiB;EACjB,sBAAuB;EACvB,mBAAoB;EACpB,SAAU;AACX;AAED;EACE,WAAY;EACZ,2BAA4B;EAC5B,cAAe;EACf,iCAAkC;AACnC;AAID;;;;;;;EAOE,kCAAmC;EACnC,gBAAiB;EACjB,wBAAyB;EACzB,iBAAkB;EAClB,SAAU;AACX;AAED;EACE,gBAAiB;EACjB,iBAAkB;EAClB,gBAAiB;EACjB,yBAA0B;EAC1B,sBAAuB;EACvB,oBAAqB;AACtB;AAID;EACE,aAAc;EACd,sBAAuB;EACvB,gBAAiB;EACjB,gBAAiB;AAClB;AAED;EACE,cAAe;AAChB;AAED;EACE,kBAAmB;EACnB,uBAAwB;EACxB,WAAY;EACZ,aAAc;EACd,mBAAoB;EACpB,uBAAwB;EACxB,mCAAoC;EACpC,iBAAkB;AACnB;AAED;EACE,oBAAqB;EACrB,eAAgB;EAChB,mBAAoB;EACpB,uBAAwB;EACxB,aAAc;EACd,cAAe;EACf,qBAAsB;AACvB;AAED;EACE,iBAAkB;EAClB,gBAAiB;EACjB,yBAA0B;EAC1B,sBAAuB;EACvB,kBAAmB;EACnB,2BAA4B;EAC5B,gBAAiB;EACjB,kBAAmB;AACpB;AAED;EACE,gBAAiB;AAClB;AAED;EACE,gBAAiB;EACjB,sBAAuB;EACvB,mBAAoB;AACrB;AAED;EACE,0BAA2B;AAC5B;AAED;EACE,kBAAmB;EACnB,6BAA8B;EAC9B,QAAS;EACT,2BAA4B;EAC5B,SAAU;EACV,uBAAwB;EACxB,gCAAiC;EACjC,iBAAkB;EAClB,cAAe;EACf,eAAgB;EAChB,gBAAiB;AAClB;AAED;EACE,WAAY;AACb;AAED;EACE,gBAAiB;EACjB,MAAO;EACP,YAAa;EACb,qBAA2D;EAA3D;IAAA,0DAA2D;EAAA;EAC3D,2BAA4B;EAC5B,oCAAqC;AACtC;AAED;EACE,2BAA4B;EAC5B,cAAe;EACf,oCAAqC;EACrC,aAAc;EACd,mBAAoB;EACpB,8BAA+B;EAC/B,SAAU;AACX;AAED;EACE,oBAAqB;EACrB,mBAAoB;EACpB,6BAA8B;EAC9B,qBAAsB;AACvB;AAED;EACE,gCAAiC;EACjC,WAAY;AACb;AAED;EACE,sCAAuC;EACvC,yCAA0C;EAC1C,kBAAmB;EACnB,gBAAiB;EACjB,sBAAuB;EACvB,yBAA0B;EAC1B,mBAAoB;EACpB,iBAAkB;AACnB;AAED;EACE,kBAAmB;EACnB,6BAA8B;EAC9B,8BAA+B;EAC/B,UAAW;EACX,iCAAkC;EAClC,WAAY;EACZ,mDAAoD;AACrD;AAED;EACE,aAAc;EACd,mBAAoB;EACpB,2BAA4B;AAC7B;AAED;EACE,gBAAiB;EACjB,kBAAmB;EACnB,qBAAsB;EACtB,iBAAkB;EAClB,YAAa;EACb,8BAA+B;AAChC;AAED;;EAEE,UAAW;AACZ;AAED;EACE,oBAAqB;AACtB;AAED;EACE,oBAAqB;EACrB,mBAAoB;EACpB,QAAS;EACT,sBAAuB;EACvB,sBAAuB;EACvB,gBAAiB;EACjB,gBAAiB;EACjB,kBAAmB;EACnB,qBAAsB;EACtB,gBAAiB;EACjB,uDAAwD;AACzD;AAED;EACE,yBAA0B;EAC1B,WAAY;EACZ,2BAA4B;AAC7B;AAED;EACE,aAAc;EACd,WAAY;EACZ,YAAa;EACb,uBAAwB;EACxB,oCAAqC;EACrC,gBAAiB;EACjB,eAAgB;EAChB,kBAAmB;AACpB;AAED;;;EAGE,kBAAmB;EACnB,SAAU;EACV,WAAY;EACZ,WAAY;EACZ,sBAAuB;EACvB,2BAA4B;EAC5B,WAAY;EACZ,kBAAmB;AACpB;AAED;EACE,QAAS;EACT,gCAAiC;AAClC;AAED;EACE,SAAU;AACX;AAED;EACE,QAAS;AACV;AAID;EACE,kBAAmB;EACnB,gBAAiB;EACjB,uBAAwB;AACzB;AAED;EACE,kBAAmB;EACnB,UAAW;EACX,2BAA4B;EAC5B,cAAe;EACf,sCAAuC;EACvC,aAAc;EACd,0BAA2B;EAC3B,mBAAoB;EACpB,4BAA6B;AAC9B;AAED;EACE,iCAAkC;EAClC,gBAAiB;EACjB,WAAY;AACb;AAED;EACE,gCAAiC;AAClC;AAED;EACE,WAAY;AACb;AAED;EACE,sBAAuB;AACxB;AAED;EACE,qCAAsC;AACvC;AAED;EACE,kCAAmC;EACnC,eAAgB;EAChB,wCAAyC;EACzC,mBAAoB;AACrB;AAED;EACE,kCAAmC;EACnC,aAAc;EACd,eAAgB;EAChB,mBAAoB;EACpB,cAAe;AAChB;AAED;EACE,kBAAmB;EACnB,QAAS;EACT,UAAW;AACZ;AAED;EACE,kBAAmB;EACnB,QAAS;EACT,WAAY;EACZ,YAAa;EACb,oBAAkB;KAAlB,iBAAkB;EAClB,0BAAwB;KAAxB,uBAAwB;AACzB;AAED;EACE,WAAY;EACZ,kBAAmB;EACnB,QAAS;EACT;;;;;;;GAOE;AACH;AAID;EACE,yDAA0D;AAC3D;AAED;EACE,uCAAwC;AACzC;AAED;EACE,oCAAqC;EACrC,eAAgB;EAChB,yCAA0C;EAC1C,mBAAoB;AACrB;AAID;EACE,kCAAmC;AACpC;AAED;EACE,0BAA2B;AAC5B;AAED;EACE,uBAAwB;EACxB,WAAY;AACb;AAED;EACE,WAAY;AACb;AAED;EACE,2CAA4C;AAC7C;AAED;EACE,WAAY;AACb;AAED;EACE,+BAAgC;AACjC;AAED;EACE,WAAY;AACb;AAED;EACE,eAAgB;EAChB,qCAAsC;AACvC;AAED;EACE,mCAAoC;AACrC;AAED;EACE,gBAAiB;EACjB,wCAAyC;EACzC,mBAAoB;AACrB;AAED;EACE,kCAAmC;AACpC;AAID;EACE,oBAAqB;EACrB,mBAAoB;EACpB,uBAAwB;EACxB,YAAa;EACb,gBAAiB;EACjB,uBAAwB;EACxB,oBAAqB;EACrB,kBAAmB;EACnB,gBAAiB;EACjB,qBAAsB;EACtB,WAAY;EACZ,yBAA0B;EAC1B,8EAA+E;EAC/E,8CAA+C;EAC/C,eAAgB;AACjB;AAED;;EAEE,2BAA4B;EAC5B,8CAA+C;AAChD;AAED;EACE,sBAAuB;EACvB,gBAAiB;EACjB,0CAA2C;AAC5C;AAED;EACE,gBAAiB;AAClB;AAED;EACE,uBAAwB;EACxB,WAAY;EACZ,qDAAsD;AACvD;AAED;EACE,oCAAqC;EACrC,gCAAiC;AAClC;AAED;EACE,gBAAiB;EACjB,YAAa;EACb,cAAe;EACf,aAAc;EACd,gBAAiB;EACjB,0BAA2B;EAC3B,0BAA2B;EAC3B,8BAA+B;EAC/B,oCAAqC;EACrC,iBAAkB;EAClB,eAAgB;AACjB;AAED;;EAEE,gBAAiB;EACjB,qBAAsB;EACtB,iBAAkB;EAClB,sCAAuC;EACvC,mBAAoB;EACpB,4BAA6B;AAC9B;AAED;EACE,oBAAqB;AACtB;AAED;EACE,wBAAyB;AAC1B;AAID;EACE,yBAA0B;EAC1B,WAAY;EACZ,iCAAkC;AACnC;AAED;EACE,aAAc;EACd,2BAA4B;AAC7B;AAED;EACE,qCAAsC;AACvC;AAED;EACE,cAAe;EACf,mBAAoB;EACpB,kBAAmB;EACnB,gBAAiB;EACjB,yBAA0B;EAC1B,sBAAuB;EACvB,gCAAiC;AAClC;AAED;EACE,WAAY;EACZ,kCAAmC;AACpC;AAED;EACE,+BAAgC;AACjC;AAED;EACE,cAAe;EACf,gBAAiB;EACjB,uBAAwB;EACxB,uCAAwC;EACxC,cAAe;EACf,oBAAqB;AACtB;AAED;EACE,cAAe;EACf,gBAAiB;EACjB,kBAAmB;EACnB,iBAAkB;EAClB,mBAAoB;AACrB;AAID;EACE,aAAc;EACd,6BAA8B;AAC/B;AAED;EACE,qCAAsC;AACvC;AAED;EACE,qCAAsC;AACvC;AAED;;;EAGE,0BAA2B;EAC3B,6BAA8B;EAC9B,4BAA6B;EAC7B,iCAAkC;AACnC;AAED;EACE,aAAc;EACd,sBAAuB;EACvB,UAAW;EACX,gBAAiB;EACjB,qBAAsB;EACtB,iBAAkB;EAClB;2BAC0B;AAC3B;AAED;EACE,2BAA4B;EAC5B,6CAA8C;EAC9C,gCAAiC;AAClC;AAED;EACE,kBAAmB;EACnB,qBAAsB;EACtB,gBAAiB;AAClB;AAED;EACE,WAAY;EACZ,YAAa;EACb,oBAAkB;KAAlB,iBAAkB;EAClB,cAAe;EACf,gCAAiC;AAClC;AAED;EACE,sBAAuB;AACxB;AAED;EACE,kBAAmB;EACnB,SAAU;EACV,UAAW;EACX,gCAAiC;EACjC,WAAY;EACZ,0BAA2B;AAC5B;AAED;EACE,aAAc;EACd,sBAAuB;EACvB,SAAU;EACV,OAAQ;EACR,iCAAkC;AACnC;AAED;EACE,kBAAmB;EACnB,gBAAiB;EACjB,yBAA0B;EAC1B,qBAAsB;EACtB,oBAAqB;AACtB;AAED;;;EAGE,SAAU;EACV,iBAAkB;EAClB,gBAAiB;EACjB,uBAAwB;AACzB;AAED;;;EAGE,SAAU;EACV,eAAgB;EAChB,mBAAoB;AACrB;AAED;EACE,gBAAiB;EACjB,gBAAiB;EACjB,gBAAiB;EACjB,kBAAmB;EACnB,oBAAqB;AACtB;AAED;EACE,uBAAwB;EACxB,YAAa;EACb,gCAAiC;EACjC,gBAAiB;EACjB,iBAAkB;AACnB;AAED;EACE,uBAAwB;EACxB,YAAa;EACb,gCAAiC;EACjC,gBAAiB;EACjB,iBAAkB;AACnB;AAED;EACE,cAAe;EACf,gBAAiB;EACjB,kBAAmB;EACnB,gBAAiB;EACjB,sBAAuB;EACvB,yBAA0B;EAC1B,oBAAqB;EACrB,mBAAoB;AACrB;AAID;EACE,qBAAsB;EACtB,iBAAkB;EAClB,kBAAmB;EACnB,gBAAiB;EACjB,yBAA0B;EAC1B,sBAAuB;EACvB,gBAAiB;AAClB;AAED;;EAEE,kCAAmC;EACnC,oBAAqB;AACtB;AAED;;EAEE,iCAAkC;EAClC,iBAAkB;AACnB;AAED;EACE,gBAAiB;EACjB,aAAc;EACd,eAAgB;EAChB,QAAS;EACT,gBAAiB;EACjB,UAAW;AACZ;AAED;EACE,iBAAkB;EAClB,iBAAkB;EAClB,gBAAiB;EACjB,6BAA8B;EAC9B,gBAAiB;EACjB,mBAAoB;AACrB;AAID;EACE,aAAc;EACd,gDAAiD;EACjD,6BAA8B;AAC/B;AAED;EACE;IACE,0BAA2B;EAC5B;AACF;AAED;EACE,wBAAyB;EACzB,0BAA2B;EAC3B,6BAA8B;EAC9B,4BAA6B;EAC7B,gBAAiB;EACjB,aAAc;EACd,sBAAuB;AACxB;AAED;EACE,kBAAmB;EACnB,mBAAoB;EACpB,gBAAiB;AAClB;AAED;EACE,kBAAmB;EACnB,4BAA6B;EAC7B,8BAA+B;EAC/B,sBAAuB;EACvB,WAAY;EACZ,iBAAkB;EAClB,kBAAmB;EACnB,gBAAiB;EACjB,yBAA0B;EAC1B,sBAAuB;AACxB;AAED;EACE,WAAY;EACZ,YAAa;EACb,oBAAkB;KAAlB,iBAAkB;EAClB,cAAe;EACf,+BAAgC;AACjC;AAED;EACE,sBAAuB;AACxB;AAED;EACE,aAAc;EACd,sBAAuB;EACvB,OAAQ;EACR,+BAAgC;AACjC;AAED;EACE,aAAc;EACd,qBAAsB;EACtB,8BAA+B;EAC/B,eAAgB;EAChB,SAAU;AACX;AAED;EACE,uCAAwC;EACxC,gBAAiB;AAClB;AAED;EACE,gBAAiB;EACjB,yCAA0C;EAC1C,gBAAiB;AAClB;AAED;EACE,gBAAiB;AAClB;AAED;EACE,oBAAqB;EACrB,mBAAoB;EACpB,QAAS;EACT,eAAgB;EAChB,gBAAiB;EACjB,kBAAmB;EACnB,oBAAqB;EACrB,gBAAiB;AAClB;AAED;EACE,aAAc;AACf;AAED;EACE,YAAa;EACb,gBAAiB;EACjB,cAAe;AAChB;AAED;EACE,YAAa;AACd;AAED;EACE,aAAc;AACf;AAED;EACE,aAAc;AACf;AAED;EACE,eAAgB;AACjB;AAED;EACE,gBAAiB;EACjB,aAAc;EACd,SAAU;EACV,mBAAoB;AACrB;AAED;EACE,SAAU;AACX;AAGD;EACE,gBAAiB;EACjB,mCAAoC;AACrC;AAED;EACE,qCAAsC;EACtC,kCAAmC;EACnC,mCAAoC;EACpC,iCAAkC;AACnC;AAED;EACE,gBAAiB;EACjB,kBAAmB;EACnB,mBAAoB;AACrB;AAID;EACE,aAAc;EACd,SAAU;AACX;AAED;EACE,4BAA6B;EAC7B,iCAAkC;EAClC,aAAc;EACd,mBAAoB;EACpB,2BAA4B;EAC5B,6BAA8B;AAC/B;AAED;EACE,aAAc;EACd,sBAAuB;EACvB,QAAS;AACV;AAED;EACE,UAAW;EACX,6BAA8B;EAC9B,8BAA+B;EAC/B,iBAAkB;EAClB,aAAc;AACf;AAED;EACE,cAAe;EACf,aAAc;AACf;AAED;EACE,mBAAoB;AACrB;AACD;EACE,6BAA8B;AAC/B;AACD;EACE,mBAAoB;AACrB;AACD;EACE,mBAAoB;AACrB;AACD;EACE,mBAAoB;AACrB;AACD;EACE,cAAe;AAChB;AACD;EACE,gCAAiC;AAClC;AAED;EACE,gBAAiB;EACjB,uBAAwB;EACxB,sCAAuC;AACxC;AAED;EACE,kBAAmB;EACnB,mBAAoB;AACrB;AAID;EACE,aAAc;EACd,SAAU;AACX;AAED;EACE,cAAe;EACf,WAAY;AACb;AAED;EACE,4BAA6B;EAC7B,+BAAgC;EAChC,aAAc;EACd,mBAAoB;EACpB,6BAA8B;AAC/B;AAED;EACE,UAAW;EACX,+BAAgC;EAChC,gCAAiC;EACjC,iBAAkB;EAClB,aAAc;AACf;AAED;EACE,aAAc;EACd,sBAAuB;EACvB,QAAS;AACV;AAED;EACE,gBAAiB;EACjB,iBAAkB;AACnB;AAED;EACE,kBAAmB;EACnB,mBAAoB;AACrB;AAED;EACE,UAAW;EACX,sBAAuB;EACvB,gBAAiB;EACjB,iBAAkB;EAClB,gBAAiB;EACjB,sBAAuB;EACvB,yBAA0B;EAC1B,gBAAiB;AAClB;AAGD;EACE,mBAAoB;AACrB;AACD;EACE,mBAAoB;AACrB;AACD;EACE,mBAAoB;AACrB;AACD;EACE,mBAAoB;AACrB;AACD;EACE,cAAe;AAChB;AACD;EACE,gCAAiC;AAClC;AACD;EACE,cAAe;EACf,aAAc;AACf;AAED;EACE,kBAAmB;EACnB,gBAAiB;EACjB,iBAAkB;EAClB,wCAAyC;EACzC,aAAc;AACf;AAED;EACE,kBAAmB;EACnB,SAAU;EACV,kBAAmB;EACnB,gBAAiB;EACjB,mBAAoB;EACpB,mBAAoB;EACpB,2BAA4B;AAC7B;AAED;EACE,WAAY;EACZ,kBAAmB;EACnB,UAAW;EACX,SAAU;EACV,UAAW;EACX,WAAY;EACZ,8BAA+B;AAChC;AAED;EACE,wBAAyB;AAC1B;AACD;EACE,OAAQ;AACT;AACD;EACE,4BAA6B;AAC9B;AACD;EACE,UAAW;EACX,QAAS;AACV;AAGD;EACE;IACE,iCAAkC;EACnC;EACD;IACE,aAAc;EACf;AACF;AAID;EACE,gBAAiB;EACjB,SAAU;EACV,UAAW;EACX,aAAc;EACd,6BAA8B;AAC/B;AAED;EACE,aAAc;EACd,SAAU;EACV,uBAAwB;AACzB;AAED;EACE,UAAW;EACX,WAAY;EACZ,YAAa;EACb,oBAAqB;EACrB,mBAAoB;EACpB,uBAAwB;EACxB,kCAAmC;EACnC,oBAAqB;EACrB,kBAAmB;EACnB,gBAAiB;EACjB,kBAAmB;AACpB;AAED;EACE,iBAAkB;EAClB,iBAAkB;EAClB,gBAAiB;EACjB,uBAAwB;AACzB;AAED;EACE,SAAU;EACV,eAAgB;EAChB,mBAAoB;AACrB;AAID;EACE,aAAc;EACd,2BAA4B;AAC7B;AAED;EACE,0BAA2B;EAC3B,6BAA8B;EAC9B,4BAA6B;EAC7B,+BAAgC;EAChC,wBAAyB;AAC1B;AAED;EACE,aAAc;EACd,mBAAoB;EACpB,eAAgB;EAChB,SAAU;EACV,mBAAoB;AACrB;AAED;EACE,gBAAiB;EACjB,mBAAoB;AACrB;AAED;EACE,uCAAwC;AACzC;AAED;EACE,aAAc;EACd,eAAgB;EAChB,cAAe;EACf,cAAe;AAChB;AAED;EACE,kBAAmB;EACnB,gBAAiB;EACjB,yBAA0B;EAC1B,qBAAsB;EACtB,oBAAqB;AACtB;AAED;EACE,eAAgB;EAChB,gBAAiB;AAClB;AAED;EACE,gBAAiB;EACjB,eAAgB;EAChB,iBAAkB;EAClB,mBAAoB;AACrB;AAED;EACE,gBAAiB;EACjB,gBAAiB;EACjB,UAAW;EACX,aAAc;EACd,qCAAsC;EACtC,SAAU;AACX;AAED;EACE,gCAAiC;EACjC,iBAAkB;AACnB;AAED;EACE,SAAU;EACV,kBAAmB;EACnB,gBAAiB;AAClB;AAED;EACE,eAAgB;EAChB,kBAAmB;EACnB,mBAAoB;AACrB;AAED;EACE,gBAAiB;AAClB;AAID;EACE,WAAY;EACZ,gBAAiB;EACjB;;;;;;GAME;EACF;;;;;;GAME;AACH;AAED;EACE,aAAc;EACd,uBAAmB;EAAnB,kBAAmB;EACnB,6CAA8C;AAC/C;AAED;EACE,4BAA6B;AAC9B;AAED;EACE,4BAA6B;AAC9B;AAED;EACE,UAAW;EACX,iCAAkC;EAClC,kBAAmB;AACpB;AAED;EACE,YAAa;EACb,WAAY;EACZ,cAAe;EACf,oBAAkB;KAAlB,iBAAkB;EAClB,gBAAiB;AAClB;AAED;EACE;IACE,wBAAyB;EAC1B;EACD;IACE,2BAA4B;EAC7B;AACF;AAED;EACE;IACE,eAAgB;EACjB;EACD;IACE,gBAAiB;EAClB;AACF;AAID;EACE,aAAc;EACd,4DAA6D;EAC7D,SAAU;AACX;AAED;EACE,SAAU;EACV,gBAAiB;EACjB,gBAAiB;EACjB,mBAAoB;AACrB;AAED;EACE,cAAe;EACf,WAAY;EACZ,YAAa;EACb,UAAW;EACX,YAAa;EACb,uBAAwB;EACxB,eAAgB;AACjB;AAED;EACE,WAAY;EACZ,YAAa;EACb,cAAe;EACf,oBAAkB;KAAlB,iBAAkB;EAClB,gCAAiC;AAClC;AAED;EACE,sBAAuB;AACxB;AAED;EACE,eAAgB;EAChB,QAAS;EACT,YAAa;EACb,aAAc;EACd,mBAAoB;EACpB,uBAAwB;EACxB,+BAAgC;EAChC,+BAAgC;AACjC;AAED;EACE,kBAAmB;EACnB,wBAAyB;EACzB,gBAAiB;AAClB;AAED;EACE,cAAe;EACf,WAAY;EACZ,gBAAiB;EACjB,sBAAoB;KAApB,mBAAoB;EACpB,gBAAiB;AAClB;AAED;EACE,kBAAmB;EACnB,SAAU;EACV,WAAY;EACZ,WAAY;EACZ,YAAa;EACb,0CAA2C;EAC3C,kBAAmB;EACnB,8BAA+B;EAC/B,WAAY;EACZ,iBAAkB;EAClB,cAAe;EACf,eAAgB;AACjB;AAED;EACE,kBAAmB;EACnB,QAAS;EACT,2BAA4B;EAC5B,WAAY;EACZ,YAAa;EACb,0CAA2C;EAC3C,kBAAmB;EACnB,8BAA+B;EAC/B,WAAY;EACZ,iBAAkB;EAClB,cAAe;EACf,eAAgB;AACjB;AAED;EACE,UAAW;AACZ;AAED;EACE,WAAY;AACb;AAID;EACE,gBAAiB;AAClB;AAED;EACE,0BAA2B;EAC3B,6BAA8B;EAC9B,4BAA6B;EAC7B,+BAAgC;AACjC;AAED;EACE,aAAc;EACd,QAAS;EACT,mBAAoB;AACrB;AAED;EACE,WAAY;EACZ,WAAY;EACZ,gBAAiB;EACjB,kCAAmC;AACpC;AAED;EACE,yBAA0B;AAC3B;AAED;EACE,gBAAiB;EACjB,gBAAiB;EACjB,yBAA0B;EAC1B,qBAAsB;EACtB,kBAAmB;EACnB,oBAAqB;AACtB;AAED;EACE,gBAAiB;EACjB,gBAAiB;EACjB,uBAAwB;EACxB,qCAAsC;EACtC,iBAAkB;AACnB;AAED;EACE,aAAc;EACd,SAAU;EACV,mBAAoB;AACrB;AAED;EACE,gBAAiB;EACjB,sBAAuB;EACvB,qBAAsB;EACtB,6BAA8B;EAC9B,gBAAiB;EACjB,aAAc;EACd,gBAAiB;EACjB,eAAgB;EAChB;wBACuB;AACxB;AAED;;EAEE,kCAAmC;EACnC,2BAA4B;EAC5B,0BAA2B;AAC5B;AAED;EACE,qCAAsC;EACtC,kBAAmB;AACpB;AAED;EACE,kBAAmB;EACnB,gBAAiB;EACjB,mBAAoB;AACrB;AAED;EACE,iCAAkC;EAClC,iBAAkB;EAClB,mBAAoB;AACrB;AAED;EACE,cAAe;EACf,gBAAiB;EACjB,yBAA0B;EAC1B,qBAAsB;EACtB,kBAAmB;EACnB,oBAAqB;EACrB,mBAAoB;AACrB;AAED;EACE,SAAU;EACV,kBAAmB;EACnB,aAAc;EACd,SAAU;EACV,mBAAoB;AACrB;AAED;EACE,gBAAiB;EACjB,iBAAkB;AACnB;AAED;EACE,aAAc;EACd,mBAAoB;EACpB,eAAgB;EAChB,SAAU;AACX;AAID;EACE,aAAc;EACd,kCAAmC;EACnC,2BAA4B;EAC5B,kBAAmB;AACpB;AAED;EACE,gBAAiB;EACjB,gBAAiB;EACjB,UAAW;EACX,aAAc;EACd,SAAU;AACX;AAED;EACE,kBAAmB;EACnB,kBAAmB;EACnB,kBAAmB;AACpB;AAED;EACE,WAAY;EACZ,kBAAmB;EACnB,OAAQ;EACR,QAAS;EACT,WAAY;EACZ,YAAa;EACb,kBAAmB;EACnB,kCAAmC;EACnC,yDAAoR;EACpR,4BAA6B;EAC7B,2BAA4B;AAC7B;AAED;EACE,0BAA2B;EAC3B,6BAA8B;EAC9B,4BAA6B;EAC7B,+BAAgC;EAChC,gBAAiB;EACjB,UAAW;AACZ;AAED;EACE,eAAgB;EAChB,gBAAiB;EACjB,uBAAwB;EACxB,iBAAkB;AACnB;AAED;EACE,gBAAiB;EACjB,kBAAmB;AACpB;AAED;;EAEE,aAAc;EACd,SAAU;EACV,yBAA0B;AAC3B;AAID;EACE,oCAAqC;AACtC;AAED;EACE,aAAc;EACd,0BAA2B;EAC3B,2BAA4B;EAC5B,kBAAmB;EACnB,gBAAiB;EACjB,mBAAoB;AACrB;AAED;EACE,eAAgB;AACjB;AAED;EACE,gCAAiC;EACjC,uBAAwB;EACxB,gBAAiB;EACjB,4BAA6B;EAC7B,+BAAgC;AACjC;AAED;EACE,SAAU;EACV,kBAAmB;EACnB,gBAAiB;EACjB,iBAAkB;AACnB;AAED;EACE,gBAAiB;EACjB,gBAAiB;EACjB,yBAA0B;EAC1B,sBAAuB;EACvB,kBAAmB;EACnB,sBAAuB;AACxB;AAED;EACE,aAAc;EACd,SAAU;AACX;AAED;EACE,gBAAiB;EACjB,iBAAkB;EAClB,qBAAsB;EACtB,sCAAuC;EACvC,uBAAmB;EAAnB,kBAAmB;EACnB,mBAAoB;AACrB;AAED;EACE,0BAA2B;EAC3B,6BAA8B;EAC9B,4BAA6B;EAC7B,iCAAkC;AACnC;AAED;EACE,kCAAmC;EACnC,mCAAoC;EACpC,iCAAkC;AACnC;AAED;EACE,eAAgB;EAChB,kBAAmB;EACnB,gBAAiB;EACjB,iBAAkB;AACnB;AAED;EACE,gBAAiB;EACjB,mBAAoB;AACrB;AAED;EACE,gBAAiB;EACjB,mBAAoB;EACpB,kBAAmB;AACpB;AAED;EACE,uBAAwB;AACzB;AAED;EACE,kCAAmC;EACnC,mBAAoB;EACpB,kBAAmB;AACpB;AAED;EACE,gBAAiB;EACjB,iBAAkB;EAClB,sCAAuC;EACvC,qBAAsB;AACvB;AAID;;EAEE,eAAgB;AACjB;AAED;EACE,aAAc;EACd,SAAU;EACV,yBAA0B;AAC3B;AAMD;EACE,iBAAkB;AACnB;AAED;EACE,cAAe;EACf,WAAY;EACZ,SAAU;AACX;AAID;EACE,yDAA0D;AAC3D;AAED;EACE,uBAAwB;EACxB,gBAAiB;EACjB,gBAAiB;EACjB,+BAAgC;EAChC,aAAc;EACd,mBAAoB;EACpB,8BAA+B;EAC/B,eAAgB;EAChB,SAAU;AACX;AAED;EACE,gBAAiB;EACjB,uCAAwC;EACxC,gBAAiB;AAClB;AAED;EACE,SAAU;EACV,eAAgB;EAChB,gCAAiC;AAClC;AAID;EACE,qCAAsC;EACtC,4BAA6B;EAC7B,+BAAgC;EAChC,0BAA2B;EAC3B,kBAAmB;EACnB,mBAAoB;AACrB;AAED;EACE,SAAU;AACX;AAID;EACE,uBAAwB;EACxB,gBAAiB;EACjB,gBAAiB;AAClB;AAED;EACE,2BAA4B;EAC5B,cAAe;EACf,sDAAuD;EACvD,aAAc;EACd,gCAAiC;EACjC,2BAA4B;AAC7B;AAED;EACE,gBAAiB;EACjB,gBAAiB;EACjB,yBAA0B;EAC1B,sBAAuB;EACvB,sBAAuB;EACvB,kBAAmB;AACpB;AAED;EACE,SAAU;EACV,eAAgB;EAChB,+BAAgC;AACjC;AAED;EACE,aAAc;EACd,qCAAsC;EACtC,SAAU;AACX;AAED;EACE,aAAc;EACd,sBAAuB;EACvB,SAAU;AACX;AAED;EACE,aAAc;EACd,sBAAuB;EACvB,QAAS;AACV;AAED;EACE,sBAAuB;AACxB;AAED;EACE,gBAAiB;EACjB,yBAA0B;EAC1B,sBAAuB;EACvB,kBAAmB;EACnB,sBAAuB;AACxB;AAED;EACE,gCAAiC;EACjC,qBAAsB;EACtB,kBAAmB;AACpB;AAED;EACE,WAAY;AACb;AAED;EACE,2BAA4B;EAC5B,cAAe;EACf,oCAAqC;EACrC,+CAAgD;EAChD,aAAc;EACd,eAAgB;EAChB,8BAA+B;EAC/B,QAAS;EACT,kBAAmB;EACnB,+BAAgC;AACjC;AAED;EACE,+BAAgC;EAChC,qBAAsB;AACvB;AAED;EACE,WAAY;AACb;AAID;EACE,gBAAiB;AAClB;AAED;EACE,kCAAmC;EACnC,iBAAkB;EAClB,mBAAoB;AACrB;AAED;EACE,qCAAsC;EACtC,uCAAwC;EACxC,gBAAiB;EACjB,uBAAwB;AACzB;AAED;;EAEE,iBAAkB;EAClB,gBAAiB;AAClB;AAED;EACE,eAAgB;EAChB,kBAAmB;EACnB,aAAc;EACd,QAAS;AACV;AAED;EACE,gBAAiB;EACjB,iBAAkB;EAClB,0BAA2B;EAC3B,oCAAqC;EACrC,0BAA2B;AAC5B;AAID;EACE;IACE,UAAW;IACX,2BAA4B;EAC7B;EACD;IACE,UAAW;IACX,wBAAyB;EAC1B;AACF;AAED;;EAEE,6DAA8D;AAC/D;AAED;EACE;IACE,qBAAsB;EACvB;EACD;;IAEE,eAAgB;EACjB;AACF;AAID;EACE;IACE,cAAe;EAChB;EAED;IACE,kBAAmB;IACnB,SAAU;IACV,OAAQ;IACR,QAAS;IACT,sBAAuB;IACvB,oBAAqB;IACrB,MAAO;IACP,qBAAsB;IACtB,oCAAqC;IACrC,wCAAyC;IACzC,aAAc;EACf;EAED;IACE,aAAc;EACf;EAED;IACE,eAAgB;IAChB,oCAAqC;IACrC,UAAW;EACZ;EAED;IACE,gBAAiB;IACjB,uBAAwB;EACzB;EAED;IACE,0BAA2B;IAC3B,qCAAsC;IACtC,aAAc;IACd,MAAO;EACR;EAED;IACE,eAAgB;IAChB,wDAAyD;EAC1D;EAID;IACE,gBAAiB;IACjB,gCAAiC;IACjC,kCAAmC;EACpC;EAID;IACE;;;;KAIE;EACH;EAED;;;IAGE,qCAAsC;EACvC;EAED;;;IAGE,0BAA2B;EAC5B;EAED;IACE,gBAAiB;EAClB;EAED;IACE,qCAAsC;EACvC;EAED;IACE,0BAA2B;EAC5B;AACF;AAED;EACE;IACE,kBAAmB;IACnB,kBAAmB;IACnB,sBAAuB;EACxB;EAED;;;;IAIE,0BAA2B;EAC5B;EAED;;IAEE,WAAY;EACb;EAED;IACE,qCAAsC;EACvC;EAED;IACE,sBAAuB;IACvB,uBAAwB;EACzB;EAED;IACE,kBAAmB;EACpB;EAGD;IACE,0BAA2B;EAC5B;AACF;AD5mCC;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA;IAAA;MAAA,sBAAmB;MAAnB,sBAAmB;MAAnB,sBAAmB;MAAnB,oBAAmB;MAAnB,oBAAmB;IAAA;EAAA;AAAA","sourcesContent":[null,"@layer theme, base, components, utilities;\n\n@layer theme {\n  @theme default {\n    --font-sans:\n      ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\",\n      \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-serif: ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif;\n    --font-mono:\n      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n\n    --color-red-50: oklch(97.1% 0.013 17.38);\n    --color-red-100: oklch(93.6% 0.032 17.717);\n    --color-red-200: oklch(88.5% 0.062 18.334);\n    --color-red-300: oklch(80.8% 0.114 19.571);\n    --color-red-400: oklch(70.4% 0.191 22.216);\n    --color-red-500: oklch(63.7% 0.237 25.331);\n    --color-red-600: oklch(57.7% 0.245 27.325);\n    --color-red-700: oklch(50.5% 0.213 27.518);\n    --color-red-800: oklch(44.4% 0.177 26.899);\n    --color-red-900: oklch(39.6% 0.141 25.723);\n    --color-red-950: oklch(25.8% 0.092 26.042);\n\n    --color-orange-50: oklch(98% 0.016 73.684);\n    --color-orange-100: oklch(95.4% 0.038 75.164);\n    --color-orange-200: oklch(90.1% 0.076 70.697);\n    --color-orange-300: oklch(83.7% 0.128 66.29);\n    --color-orange-400: oklch(75% 0.183 55.934);\n    --color-orange-500: oklch(70.5% 0.213 47.604);\n    --color-orange-600: oklch(64.6% 0.222 41.116);\n    --color-orange-700: oklch(55.3% 0.195 38.402);\n    --color-orange-800: oklch(47% 0.157 37.304);\n    --color-orange-900: oklch(40.8% 0.123 38.172);\n    --color-orange-950: oklch(26.6% 0.079 36.259);\n\n    --color-amber-50: oklch(98.7% 0.022 95.277);\n    --color-amber-100: oklch(96.2% 0.059 95.617);\n    --color-amber-200: oklch(92.4% 0.12 95.746);\n    --color-amber-300: oklch(87.9% 0.169 91.605);\n    --color-amber-400: oklch(82.8% 0.189 84.429);\n    --color-amber-500: oklch(76.9% 0.188 70.08);\n    --color-amber-600: oklch(66.6% 0.179 58.318);\n    --color-amber-700: oklch(55.5% 0.163 48.998);\n    --color-amber-800: oklch(47.3% 0.137 46.201);\n    --color-amber-900: oklch(41.4% 0.112 45.904);\n    --color-amber-950: oklch(27.9% 0.077 45.635);\n\n    --color-yellow-50: oklch(98.7% 0.026 102.212);\n    --color-yellow-100: oklch(97.3% 0.071 103.193);\n    --color-yellow-200: oklch(94.5% 0.129 101.54);\n    --color-yellow-300: oklch(90.5% 0.182 98.111);\n    --color-yellow-400: oklch(85.2% 0.199 91.936);\n    --color-yellow-500: oklch(79.5% 0.184 86.047);\n    --color-yellow-600: oklch(68.1% 0.162 75.834);\n    --color-yellow-700: oklch(55.4% 0.135 66.442);\n    --color-yellow-800: oklch(47.6% 0.114 61.907);\n    --color-yellow-900: oklch(42.1% 0.095 57.708);\n    --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n    --color-lime-50: oklch(98.6% 0.031 120.757);\n    --color-lime-100: oklch(96.7% 0.067 122.328);\n    --color-lime-200: oklch(93.8% 0.127 124.321);\n    --color-lime-300: oklch(89.7% 0.196 126.665);\n    --color-lime-400: oklch(84.1% 0.238 128.85);\n    --color-lime-500: oklch(76.8% 0.233 130.85);\n    --color-lime-600: oklch(64.8% 0.2 131.684);\n    --color-lime-700: oklch(53.2% 0.157 131.589);\n    --color-lime-800: oklch(45.3% 0.124 130.933);\n    --color-lime-900: oklch(40.5% 0.101 131.063);\n    --color-lime-950: oklch(27.4% 0.072 132.109);\n\n    --color-green-50: oklch(98.2% 0.018 155.826);\n    --color-green-100: oklch(96.2% 0.044 156.743);\n    --color-green-200: oklch(92.5% 0.084 155.995);\n    --color-green-300: oklch(87.1% 0.15 154.449);\n    --color-green-400: oklch(79.2% 0.209 151.711);\n    --color-green-500: oklch(72.3% 0.219 149.579);\n    --color-green-600: oklch(62.7% 0.194 149.214);\n    --color-green-700: oklch(52.7% 0.154 150.069);\n    --color-green-800: oklch(44.8% 0.119 151.328);\n    --color-green-900: oklch(39.3% 0.095 152.535);\n    --color-green-950: oklch(26.6% 0.065 152.934);\n\n    --color-emerald-50: oklch(97.9% 0.021 166.113);\n    --color-emerald-100: oklch(95% 0.052 163.051);\n    --color-emerald-200: oklch(90.5% 0.093 164.15);\n    --color-emerald-300: oklch(84.5% 0.143 164.978);\n    --color-emerald-400: oklch(76.5% 0.177 163.223);\n    --color-emerald-500: oklch(69.6% 0.17 162.48);\n    --color-emerald-600: oklch(59.6% 0.145 163.225);\n    --color-emerald-700: oklch(50.8% 0.118 165.612);\n    --color-emerald-800: oklch(43.2% 0.095 166.913);\n    --color-emerald-900: oklch(37.8% 0.077 168.94);\n    --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n    --color-teal-50: oklch(98.4% 0.014 180.72);\n    --color-teal-100: oklch(95.3% 0.051 180.801);\n    --color-teal-200: oklch(91% 0.096 180.426);\n    --color-teal-300: oklch(85.5% 0.138 181.071);\n    --color-teal-400: oklch(77.7% 0.152 181.912);\n    --color-teal-500: oklch(70.4% 0.14 182.503);\n    --color-teal-600: oklch(60% 0.118 184.704);\n    --color-teal-700: oklch(51.1% 0.096 186.391);\n    --color-teal-800: oklch(43.7% 0.078 188.216);\n    --color-teal-900: oklch(38.6% 0.063 188.416);\n    --color-teal-950: oklch(27.7% 0.046 192.524);\n\n    --color-cyan-50: oklch(98.4% 0.019 200.873);\n    --color-cyan-100: oklch(95.6% 0.045 203.388);\n    --color-cyan-200: oklch(91.7% 0.08 205.041);\n    --color-cyan-300: oklch(86.5% 0.127 207.078);\n    --color-cyan-400: oklch(78.9% 0.154 211.53);\n    --color-cyan-500: oklch(71.5% 0.143 215.221);\n    --color-cyan-600: oklch(60.9% 0.126 221.723);\n    --color-cyan-700: oklch(52% 0.105 223.128);\n    --color-cyan-800: oklch(45% 0.085 224.283);\n    --color-cyan-900: oklch(39.8% 0.07 227.392);\n    --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n    --color-sky-50: oklch(97.7% 0.013 236.62);\n    --color-sky-100: oklch(95.1% 0.026 236.824);\n    --color-sky-200: oklch(90.1% 0.058 230.902);\n    --color-sky-300: oklch(82.8% 0.111 230.318);\n    --color-sky-400: oklch(74.6% 0.16 232.661);\n    --color-sky-500: oklch(68.5% 0.169 237.323);\n    --color-sky-600: oklch(58.8% 0.158 241.966);\n    --color-sky-700: oklch(50% 0.134 242.749);\n    --color-sky-800: oklch(44.3% 0.11 240.79);\n    --color-sky-900: oklch(39.1% 0.09 240.876);\n    --color-sky-950: oklch(29.3% 0.066 243.157);\n\n    --color-blue-50: oklch(97% 0.014 254.604);\n    --color-blue-100: oklch(93.2% 0.032 255.585);\n    --color-blue-200: oklch(88.2% 0.059 254.128);\n    --color-blue-300: oklch(80.9% 0.105 251.813);\n    --color-blue-400: oklch(70.7% 0.165 254.624);\n    --color-blue-500: oklch(62.3% 0.214 259.815);\n    --color-blue-600: oklch(54.6% 0.245 262.881);\n    --color-blue-700: oklch(48.8% 0.243 264.376);\n    --color-blue-800: oklch(42.4% 0.199 265.638);\n    --color-blue-900: oklch(37.9% 0.146 265.522);\n    --color-blue-950: oklch(28.2% 0.091 267.935);\n\n    --color-indigo-50: oklch(96.2% 0.018 272.314);\n    --color-indigo-100: oklch(93% 0.034 272.788);\n    --color-indigo-200: oklch(87% 0.065 274.039);\n    --color-indigo-300: oklch(78.5% 0.115 274.713);\n    --color-indigo-400: oklch(67.3% 0.182 276.935);\n    --color-indigo-500: oklch(58.5% 0.233 277.117);\n    --color-indigo-600: oklch(51.1% 0.262 276.966);\n    --color-indigo-700: oklch(45.7% 0.24 277.023);\n    --color-indigo-800: oklch(39.8% 0.195 277.366);\n    --color-indigo-900: oklch(35.9% 0.144 278.697);\n    --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n    --color-violet-50: oklch(96.9% 0.016 293.756);\n    --color-violet-100: oklch(94.3% 0.029 294.588);\n    --color-violet-200: oklch(89.4% 0.057 293.283);\n    --color-violet-300: oklch(81.1% 0.111 293.571);\n    --color-violet-400: oklch(70.2% 0.183 293.541);\n    --color-violet-500: oklch(60.6% 0.25 292.717);\n    --color-violet-600: oklch(54.1% 0.281 293.009);\n    --color-violet-700: oklch(49.1% 0.27 292.581);\n    --color-violet-800: oklch(43.2% 0.232 292.759);\n    --color-violet-900: oklch(38% 0.189 293.745);\n    --color-violet-950: oklch(28.3% 0.141 291.089);\n\n    --color-purple-50: oklch(97.7% 0.014 308.299);\n    --color-purple-100: oklch(94.6% 0.033 307.174);\n    --color-purple-200: oklch(90.2% 0.063 306.703);\n    --color-purple-300: oklch(82.7% 0.119 306.383);\n    --color-purple-400: oklch(71.4% 0.203 305.504);\n    --color-purple-500: oklch(62.7% 0.265 303.9);\n    --color-purple-600: oklch(55.8% 0.288 302.321);\n    --color-purple-700: oklch(49.6% 0.265 301.924);\n    --color-purple-800: oklch(43.8% 0.218 303.724);\n    --color-purple-900: oklch(38.1% 0.176 304.987);\n    --color-purple-950: oklch(29.1% 0.149 302.717);\n\n    --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n    --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n    --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n    --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n    --color-fuchsia-400: oklch(74% 0.238 322.16);\n    --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n    --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n    --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n    --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n    --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n    --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n    --color-pink-50: oklch(97.1% 0.014 343.198);\n    --color-pink-100: oklch(94.8% 0.028 342.258);\n    --color-pink-200: oklch(89.9% 0.061 343.231);\n    --color-pink-300: oklch(82.3% 0.12 346.018);\n    --color-pink-400: oklch(71.8% 0.202 349.761);\n    --color-pink-500: oklch(65.6% 0.241 354.308);\n    --color-pink-600: oklch(59.2% 0.249 0.584);\n    --color-pink-700: oklch(52.5% 0.223 3.958);\n    --color-pink-800: oklch(45.9% 0.187 3.815);\n    --color-pink-900: oklch(40.8% 0.153 2.432);\n    --color-pink-950: oklch(28.4% 0.109 3.907);\n\n    --color-rose-50: oklch(96.9% 0.015 12.422);\n    --color-rose-100: oklch(94.1% 0.03 12.58);\n    --color-rose-200: oklch(89.2% 0.058 10.001);\n    --color-rose-300: oklch(81% 0.117 11.638);\n    --color-rose-400: oklch(71.2% 0.194 13.428);\n    --color-rose-500: oklch(64.5% 0.246 16.439);\n    --color-rose-600: oklch(58.6% 0.253 17.585);\n    --color-rose-700: oklch(51.4% 0.222 16.935);\n    --color-rose-800: oklch(45.5% 0.188 13.697);\n    --color-rose-900: oklch(41% 0.159 10.272);\n    --color-rose-950: oklch(27.1% 0.105 12.094);\n\n    --color-slate-50: oklch(98.4% 0.003 247.858);\n    --color-slate-100: oklch(96.8% 0.007 247.896);\n    --color-slate-200: oklch(92.9% 0.013 255.508);\n    --color-slate-300: oklch(86.9% 0.022 252.894);\n    --color-slate-400: oklch(70.4% 0.04 256.788);\n    --color-slate-500: oklch(55.4% 0.046 257.417);\n    --color-slate-600: oklch(44.6% 0.043 257.281);\n    --color-slate-700: oklch(37.2% 0.044 257.287);\n    --color-slate-800: oklch(27.9% 0.041 260.031);\n    --color-slate-900: oklch(20.8% 0.042 265.755);\n    --color-slate-950: oklch(12.9% 0.042 264.695);\n\n    --color-gray-50: oklch(98.5% 0.002 247.839);\n    --color-gray-100: oklch(96.7% 0.003 264.542);\n    --color-gray-200: oklch(92.8% 0.006 264.531);\n    --color-gray-300: oklch(87.2% 0.01 258.338);\n    --color-gray-400: oklch(70.7% 0.022 261.325);\n    --color-gray-500: oklch(55.1% 0.027 264.364);\n    --color-gray-600: oklch(44.6% 0.03 256.802);\n    --color-gray-700: oklch(37.3% 0.034 259.733);\n    --color-gray-800: oklch(27.8% 0.033 256.848);\n    --color-gray-900: oklch(21% 0.034 264.665);\n    --color-gray-950: oklch(13% 0.028 261.692);\n\n    --color-zinc-50: oklch(98.5% 0 0);\n    --color-zinc-100: oklch(96.7% 0.001 286.375);\n    --color-zinc-200: oklch(92% 0.004 286.32);\n    --color-zinc-300: oklch(87.1% 0.006 286.286);\n    --color-zinc-400: oklch(70.5% 0.015 286.067);\n    --color-zinc-500: oklch(55.2% 0.016 285.938);\n    --color-zinc-600: oklch(44.2% 0.017 285.786);\n    --color-zinc-700: oklch(37% 0.013 285.805);\n    --color-zinc-800: oklch(27.4% 0.006 286.033);\n    --color-zinc-900: oklch(21% 0.006 285.885);\n    --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n    --color-neutral-50: oklch(98.5% 0 0);\n    --color-neutral-100: oklch(97% 0 0);\n    --color-neutral-200: oklch(92.2% 0 0);\n    --color-neutral-300: oklch(87% 0 0);\n    --color-neutral-400: oklch(70.8% 0 0);\n    --color-neutral-500: oklch(55.6% 0 0);\n    --color-neutral-600: oklch(43.9% 0 0);\n    --color-neutral-700: oklch(37.1% 0 0);\n    --color-neutral-800: oklch(26.9% 0 0);\n    --color-neutral-900: oklch(20.5% 0 0);\n    --color-neutral-950: oklch(14.5% 0 0);\n\n    --color-stone-50: oklch(98.5% 0.001 106.423);\n    --color-stone-100: oklch(97% 0.001 106.424);\n    --color-stone-200: oklch(92.3% 0.003 48.717);\n    --color-stone-300: oklch(86.9% 0.005 56.366);\n    --color-stone-400: oklch(70.9% 0.01 56.259);\n    --color-stone-500: oklch(55.3% 0.013 58.071);\n    --color-stone-600: oklch(44.4% 0.011 73.639);\n    --color-stone-700: oklch(37.4% 0.01 67.558);\n    --color-stone-800: oklch(26.8% 0.007 34.298);\n    --color-stone-900: oklch(21.6% 0.006 56.043);\n    --color-stone-950: oklch(14.7% 0.004 49.25);\n\n    --color-mauve-50: oklch(98.5% 0 0);\n    --color-mauve-100: oklch(96% 0.003 325.6);\n    --color-mauve-200: oklch(92.2% 0.005 325.62);\n    --color-mauve-300: oklch(86.5% 0.012 325.68);\n    --color-mauve-400: oklch(71.1% 0.019 323.02);\n    --color-mauve-500: oklch(54.2% 0.034 322.5);\n    --color-mauve-600: oklch(43.5% 0.029 321.78);\n    --color-mauve-700: oklch(36.4% 0.029 323.89);\n    --color-mauve-800: oklch(26.3% 0.024 320.12);\n    --color-mauve-900: oklch(21.2% 0.019 322.12);\n    --color-mauve-950: oklch(14.5% 0.008 326);\n\n    --color-olive-50: oklch(98.8% 0.003 106.5);\n    --color-olive-100: oklch(96.6% 0.005 106.5);\n    --color-olive-200: oklch(93% 0.007 106.5);\n    --color-olive-300: oklch(88% 0.011 106.6);\n    --color-olive-400: oklch(73.7% 0.021 106.9);\n    --color-olive-500: oklch(58% 0.031 107.3);\n    --color-olive-600: oklch(46.6% 0.025 107.3);\n    --color-olive-700: oklch(39.4% 0.023 107.4);\n    --color-olive-800: oklch(28.6% 0.016 107.4);\n    --color-olive-900: oklch(22.8% 0.013 107.4);\n    --color-olive-950: oklch(15.3% 0.006 107.1);\n\n    --color-mist-50: oklch(98.7% 0.002 197.1);\n    --color-mist-100: oklch(96.3% 0.002 197.1);\n    --color-mist-200: oklch(92.5% 0.005 214.3);\n    --color-mist-300: oklch(87.2% 0.007 219.6);\n    --color-mist-400: oklch(72.3% 0.014 214.4);\n    --color-mist-500: oklch(56% 0.021 213.5);\n    --color-mist-600: oklch(45% 0.017 213.2);\n    --color-mist-700: oklch(37.8% 0.015 216);\n    --color-mist-800: oklch(27.5% 0.011 216.9);\n    --color-mist-900: oklch(21.8% 0.008 223.9);\n    --color-mist-950: oklch(14.8% 0.004 228.8);\n\n    --color-taupe-50: oklch(98.6% 0.002 67.8);\n    --color-taupe-100: oklch(96% 0.002 17.2);\n    --color-taupe-200: oklch(92.2% 0.005 34.3);\n    --color-taupe-300: oklch(86.8% 0.007 39.5);\n    --color-taupe-400: oklch(71.4% 0.014 41.2);\n    --color-taupe-500: oklch(54.7% 0.021 43.1);\n    --color-taupe-600: oklch(43.8% 0.017 39.3);\n    --color-taupe-700: oklch(36.7% 0.016 35.7);\n    --color-taupe-800: oklch(26.8% 0.011 36.5);\n    --color-taupe-900: oklch(21.4% 0.009 43.1);\n    --color-taupe-950: oklch(14.7% 0.004 49.3);\n\n    --color-black: #000;\n    --color-white: #fff;\n\n    --spacing: 0.25rem;\n\n    --breakpoint-sm: 40rem;\n    --breakpoint-md: 48rem;\n    --breakpoint-lg: 64rem;\n    --breakpoint-xl: 80rem;\n    --breakpoint-2xl: 96rem;\n\n    --container-3xs: 16rem;\n    --container-2xs: 18rem;\n    --container-xs: 20rem;\n    --container-sm: 24rem;\n    --container-md: 28rem;\n    --container-lg: 32rem;\n    --container-xl: 36rem;\n    --container-2xl: 42rem;\n    --container-3xl: 48rem;\n    --container-4xl: 56rem;\n    --container-5xl: 64rem;\n    --container-6xl: 72rem;\n    --container-7xl: 80rem;\n\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-xl: 1.25rem;\n    --text-xl--line-height: calc(1.75 / 1.25);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --text-5xl: 3rem;\n    --text-5xl--line-height: 1;\n    --text-6xl: 3.75rem;\n    --text-6xl--line-height: 1;\n    --text-7xl: 4.5rem;\n    --text-7xl--line-height: 1;\n    --text-8xl: 6rem;\n    --text-8xl--line-height: 1;\n    --text-9xl: 8rem;\n    --text-9xl--line-height: 1;\n\n    --font-weight-thin: 100;\n    --font-weight-extralight: 200;\n    --font-weight-light: 300;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --font-weight-black: 900;\n\n    --tracking-tighter: -0.05em;\n    --tracking-tight: -0.025em;\n    --tracking-normal: 0em;\n    --tracking-wide: 0.025em;\n    --tracking-wider: 0.05em;\n    --tracking-widest: 0.1em;\n\n    --leading-tight: 1.25;\n    --leading-snug: 1.375;\n    --leading-normal: 1.5;\n    --leading-relaxed: 1.625;\n    --leading-loose: 2;\n\n    --radius-xs: 0.125rem;\n    --radius-sm: 0.25rem;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --radius-4xl: 2rem;\n\n    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-md:\n      0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    --shadow-lg:\n      0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --shadow-xl:\n      0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n    --text-shadow-sm:\n      0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),\n      0px 2px 2px rgb(0 0 0 / 0.075);\n    --text-shadow-md:\n      0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),\n      0px 2px 4px rgb(0 0 0 / 0.1);\n    --text-shadow-lg:\n      0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),\n      0px 4px 8px rgb(0 0 0 / 0.1);\n\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n    --animate-spin: spin 1s linear infinite;\n    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-bounce: bounce 1s infinite;\n\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes ping {\n      75%,\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes pulse {\n      50% {\n        opacity: 0.5;\n      }\n    }\n\n    @keyframes bounce {\n      0%,\n      100% {\n        transform: translateY(-25%);\n        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n      }\n\n      50% {\n        transform: none;\n        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n\n    --blur-xs: 4px;\n    --blur-sm: 8px;\n    --blur-md: 12px;\n    --blur-lg: 16px;\n    --blur-xl: 24px;\n    --blur-2xl: 40px;\n    --blur-3xl: 64px;\n\n    --perspective-dramatic: 100px;\n    --perspective-near: 300px;\n    --perspective-normal: 500px;\n    --perspective-midrange: 800px;\n    --perspective-distant: 1200px;\n\n    --aspect-video: 16 / 9;\n\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: --theme(--font-sans, initial);\n    --default-font-feature-settings: --theme(\n      --font-sans--font-feature-settings,\n      initial\n    );\n    --default-font-variation-settings: --theme(\n      --font-sans--font-variation-settings,\n      initial\n    );\n    --default-mono-font-family: --theme(--font-mono, initial);\n    --default-mono-font-feature-settings: --theme(\n      --font-mono--font-feature-settings,\n      initial\n    );\n    --default-mono-font-variation-settings: --theme(\n      --font-mono--font-variation-settings,\n      initial\n    );\n  }\n\n  /* Deprecated */\n  @theme default inline reference {\n    --blur: 8px;\n    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n    --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n    --radius: 0.25rem;\n    --max-width-prose: 65ch;\n  }\n}\n\n@layer base {\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    box-sizing: border-box; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 2 */\n    border: 0 solid; /* 3 */\n  }\n\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    tab-size: 4; /* 3 */\n    font-family: --theme(\n      --default-font-family,\n      ui-sans-serif,\n      system-ui,\n      sans-serif,\n      \"Apple Color Emoji\",\n      \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\",\n      \"Noto Color Emoji\"\n    ); /* 4 */\n    font-feature-settings: --theme(\n      --default-font-feature-settings,\n      normal\n    ); /* 5 */\n    font-variation-settings: --theme(\n      --default-font-variation-settings,\n      normal\n    ); /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  /*\n  Remove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\n  Add the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: --theme(\n      --default-mono-font-family,\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      \"Liberation Mono\",\n      \"Courier New\",\n      monospace\n    ); /* 1 */\n    font-feature-settings: --theme(\n      --default-mono-font-feature-settings,\n      normal\n    ); /* 2 */\n    font-variation-settings: --theme(\n      --default-mono-font-variation-settings,\n      normal\n    ); /* 3 */\n    font-size: 1em; /* 4 */\n  }\n\n  /*\n  Add the correct font size in all browsers.\n*/\n\n  small {\n    font-size: 80%;\n  }\n\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring {\n    outline: auto;\n  }\n\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\n  Add the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\n  Make lists unstyled by default.\n*/\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n  }\n\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  /*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\n  button,\n  input,\n  select,\n  optgroup,\n  textarea,\n  ::file-selector-button {\n    font: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    border-radius: 0; /* 2 */\n    background-color: transparent; /* 3 */\n    opacity: 1; /* 4 */\n  }\n\n  /*\n  Restore default font weight.\n*/\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  /*\n  Restore indentation.\n*/\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  /*\n  Restore space after button.\n*/\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  /*\n  Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n*/\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  /*\n  Set the default placeholder color to a semi-transparent version of the current text color in browsers that do not\n  crash when using `color-mix(…)` with `currentcolor`. (https://github.com/tailwindlabs/tailwindcss/issues/17194)\n*/\n\n  @supports (not (-webkit-appearance: -apple-pay-button)) /* Not Safari */ or\n    (contain-intrinsic-size: 1px) /* Safari 17+ */ {\n    ::placeholder {\n      color: color-mix(in oklab, currentcolor 50%, transparent);\n    }\n  }\n\n  /*\n  Prevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh; /* 1 */\n    text-align: inherit; /* 2 */\n  }\n\n  /*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  /*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit,\n  ::-webkit-datetime-edit-year-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-minute-field,\n  ::-webkit-datetime-edit-second-field,\n  ::-webkit-datetime-edit-millisecond-field,\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  /*\n  Center dropdown marker shown on inputs with paired `<datalist>`s in Chrome. (https://github.com/tailwindlabs/tailwindcss/issues/18499)\n*/\n\n  ::-webkit-calendar-picker-indicator {\n    line-height: 1;\n  }\n\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\n  button,\n  input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]),\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n\n@layer utilities {\n  @tailwind utilities;\n}\n","@import \"tailwindcss\";\n@import url(\"https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap\");\n\n:root {\n  color-scheme: light;\n  --bg: #ece2bd;\n  --bg-soft: #f1e8ca;\n  --surface: #f6efd6;\n  --ink: #18140d;\n  --muted: rgba(24, 20, 13, 0.62);\n  --dark: #141009;\n  --accent: #f44700;\n  --accent-2: #ffc240;\n  --line: rgba(24, 20, 13, 0.14);\n  --line-strong: rgba(24, 20, 13, 0.26);\n  --container: 1240px;\n  --radius: 0;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n  margin: 0;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Manrope\", \"Segoe UI\", sans-serif;\n  font-size: 17px;\n  color: var(--ink);\n  background: var(--bg);\n  line-height: 1.6;\n  -webkit-font-smoothing: antialiased;\n}\n\nimg {\n  max-width: 100%;\n}\n\na {\n  color: inherit;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.container {\n  width: 100%;\n  max-width: var(--container);\n  margin: 0 auto;\n  padding: 0 clamp(20px, 5vw, 48px);\n}\n\n/* ---------- Typography ---------- */\n\n.hero-title,\n.page-title,\n.section-title,\n.wizard-headline,\n.event-title,\n.case-title,\n.cta-band h2 {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 800;\n  letter-spacing: -0.025em;\n  line-height: 1.03;\n  margin: 0;\n}\n\n.kicker {\n  margin: 0 0 22px;\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: var(--accent);\n}\n\n/* ---------- Layout shell ---------- */\n\n.site {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  overflow-x: clip;\n}\n\n.site-main {\n  flex: 1 1 auto;\n}\n\n.site-banner {\n  position: relative;\n  background: var(--dark);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 9px clamp(44px, 7vw, 60px);\n  font-size: 0.9rem;\n}\n\n.site-banner-link {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 6px 12px;\n  color: inherit;\n  text-decoration: none;\n}\n\n.site-banner-tag {\n  font-size: 0.6rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.09em;\n  color: var(--dark);\n  background: var(--accent-2);\n  padding: 2px 6px;\n  border-radius: 3px;\n}\n\n.site-banner-text {\n  font-weight: 600;\n}\n\n.site-banner-cta {\n  font-weight: 700;\n  color: var(--accent-2);\n  white-space: nowrap;\n}\n\n.site-banner-link:hover .site-banner-cta {\n  text-decoration: underline;\n}\n\n.site-banner-close {\n  position: absolute;\n  right: clamp(10px, 3vw, 18px);\n  top: 50%;\n  transform: translateY(-50%);\n  border: 0;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.65);\n  font-size: 1.3rem;\n  line-height: 1;\n  cursor: pointer;\n  padding: 4px 8px;\n}\n\n.site-banner-close:hover {\n  color: #fff;\n}\n\n.site-header {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background: color-mix(in srgb, var(--bg) 88%, transparent);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid var(--line);\n}\n\n.site-header-inner {\n  max-width: var(--container);\n  margin: 0 auto;\n  padding: 16px clamp(20px, 5vw, 48px);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n}\n\n.site-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: clamp(10px, 1.5vw, 16px);\n  text-decoration: none;\n}\n\n.site-brand img {\n  height: clamp(38px, 4.5vw, 52px);\n  width: auto;\n}\n\n.site-brand-partner {\n  padding-left: clamp(10px, 1.5vw, 16px);\n  border-left: 1px solid var(--line-strong);\n  font-size: 0.82rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  color: var(--ink);\n}\n\n.hero-partner-badge {\n  position: absolute;\n  right: clamp(20px, 5vw, 48px);\n  bottom: clamp(24px, 4vw, 52px);\n  z-index: 2;\n  height: clamp(104px, 12vw, 148px);\n  width: auto;\n  filter: drop-shadow(0 8px 22px rgba(0, 0, 0, 0.45));\n}\n\n.site-nav {\n  display: flex;\n  align-items: center;\n  gap: clamp(14px, 2vw, 32px);\n}\n\n.site-nav-link {\n  font-weight: 600;\n  font-size: 0.98rem;\n  text-decoration: none;\n  color: var(--ink);\n  opacity: 0.7;\n  transition: opacity 160ms ease;\n}\n\n.site-nav-link:hover,\n.site-nav-link.is-active {\n  opacity: 1;\n}\n\n.site-nav-link.is-active {\n  color: var(--accent);\n}\n\n.nav-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0.6rem 1.2rem;\n  background: var(--ink);\n  color: var(--bg);\n  font-weight: 700;\n  font-size: 0.95rem;\n  text-decoration: none;\n  border-radius: 0;\n  transition: background 160ms ease, transform 160ms ease;\n}\n\n.nav-cta:hover {\n  background: var(--accent);\n  color: #fff;\n  transform: translateY(-1px);\n}\n\n.nav-toggle {\n  display: none;\n  width: 44px;\n  height: 40px;\n  background: transparent;\n  border: 1px solid var(--line-strong);\n  border-radius: 0;\n  cursor: pointer;\n  position: relative;\n}\n\n.nav-toggle-bars,\n.nav-toggle-bars::before,\n.nav-toggle-bars::after {\n  position: absolute;\n  left: 50%;\n  width: 20px;\n  height: 2px;\n  background: var(--ink);\n  transform: translateX(-50%);\n  content: \"\";\n  border-radius: 2px;\n}\n\n.nav-toggle-bars {\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.nav-toggle-bars::before {\n  top: -6px;\n}\n\n.nav-toggle-bars::after {\n  top: 6px;\n}\n\n/* ---------- Hero ---------- */\n\n.hero {\n  position: relative;\n  overflow: hidden;\n  background: var(--dark);\n}\n\n.hero-inner {\n  position: relative;\n  z-index: 1;\n  max-width: var(--container);\n  margin: 0 auto;\n  padding-inline: clamp(20px, 5vw, 48px);\n  display: grid;\n  grid-template-columns: 1fr;\n  align-items: center;\n  min-height: min(86vh, 760px);\n}\n\n.hero-copy {\n  padding: clamp(48px, 8vw, 96px) 0;\n  max-width: 600px;\n  color: #fff;\n}\n\n.hero-copy .hero-lead {\n  color: rgba(255, 255, 255, 0.82);\n}\n\n.hero-copy .link-button-arrow {\n  color: #fff;\n}\n\n.hero-copy .link-button-arrow:hover {\n  color: var(--accent-2);\n}\n\n.hero-title {\n  font-size: clamp(2.9rem, 7vw, 5.4rem);\n}\n\n.hero-lead {\n  margin: clamp(22px, 3vw, 30px) 0 0;\n  max-width: 48ch;\n  font-size: clamp(1.05rem, 1.4vw, 1.3rem);\n  color: var(--muted);\n}\n\n.hero-cta-row {\n  margin-top: clamp(30px, 4vw, 44px);\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 18px 30px;\n}\n\n.hero-visual {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n}\n\n.hero-visual > img:not(.hero-partner-badge) {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.hero-visual::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    90deg,\n    rgba(10, 8, 4, 0.92) 0%,\n    rgba(10, 8, 4, 0.78) 28%,\n    rgba(10, 8, 4, 0.5) 52%,\n    rgba(10, 8, 4, 0.12) 78%,\n    transparent 100%\n  );\n}\n\n/* ---------- Page hero (inner pages) ---------- */\n\n.page-hero {\n  padding: clamp(56px, 9vw, 130px) 0 clamp(36px, 5vw, 64px);\n}\n\n.page-title {\n  font-size: clamp(2.4rem, 5.5vw, 4.4rem);\n}\n\n.page-lead {\n  margin: clamp(20px, 2.5vw, 28px) 0 0;\n  max-width: 60ch;\n  font-size: clamp(1.05rem, 1.4vw, 1.28rem);\n  color: var(--muted);\n}\n\n/* ---------- Sections ---------- */\n\n.section {\n  padding: clamp(56px, 9vw, 130px) 0;\n}\n\n.section-alt {\n  background: var(--bg-soft);\n}\n\n.section-dark {\n  background: var(--dark);\n  color: #fff;\n}\n\n.section-dark .section-title {\n  color: #fff;\n}\n\n.section-dark .principle-card {\n  border-top-color: rgba(255, 255, 255, 0.85);\n}\n\n.section-dark .principle-card h3 {\n  color: #fff;\n}\n\n.section-dark .principle-card p {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.section-dark .link-button-arrow {\n  color: #fff;\n}\n\n.section-head {\n  max-width: 62ch;\n  margin-bottom: clamp(34px, 5vw, 60px);\n}\n\n.section-title {\n  font-size: clamp(2rem, 4vw, 3.2rem);\n}\n\n.section-intro {\n  margin: 20px 0 0;\n  font-size: clamp(1.05rem, 1.3vw, 1.2rem);\n  color: var(--muted);\n}\n\n.section-foot {\n  margin-top: clamp(34px, 5vw, 52px);\n}\n\n/* ---------- Buttons / links ---------- */\n\n.cta-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 0;\n  padding: 0.95rem 1.9rem;\n  font-family: inherit;\n  font-size: 1.02rem;\n  font-weight: 700;\n  text-decoration: none;\n  color: #fff;\n  background: var(--accent);\n  transition: transform 180ms ease, box-shadow 180ms ease, background 180ms ease;\n  box-shadow: 0 12px 26px rgba(244, 71, 0, 0.26);\n  cursor: pointer;\n}\n\n.cta-button:hover,\n.cta-button:focus-visible {\n  transform: translateY(-2px);\n  box-shadow: 0 16px 32px rgba(244, 71, 0, 0.32);\n}\n\n.cta-button-light {\n  background: var(--ink);\n  color: var(--bg);\n  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.2);\n}\n\n.cta-button-light:hover {\n  background: #000;\n}\n\n.cta-button-outline {\n  background: transparent;\n  color: #fff;\n  box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.55);\n}\n\n.cta-button-outline:hover {\n  background: rgba(255, 255, 255, 0.1);\n  box-shadow: inset 0 0 0 2px #fff;\n}\n\n.link-button {\n  background: none;\n  border: none;\n  padding: 6px 0;\n  font: inherit;\n  font-weight: 700;\n  text-decoration: underline;\n  text-underline-offset: 5px;\n  text-decoration-thickness: 2px;\n  text-decoration-color: var(--accent);\n  color: var(--ink);\n  cursor: pointer;\n}\n\n.link-button-arrow,\n.inline-link {\n  font-weight: 700;\n  text-decoration: none;\n  color: var(--ink);\n  border-bottom: 2px solid var(--accent);\n  padding-bottom: 3px;\n  transition: color 160ms ease;\n}\n\n.link-button-arrow:hover {\n  color: var(--accent);\n}\n\n.inline-link {\n  border-bottom-width: 1px;\n}\n\n/* ---------- Stat strip / blocks ---------- */\n\n.strip-stats {\n  background: var(--accent);\n  color: #fff;\n  padding: clamp(48px, 7vw, 90px) 0;\n}\n\n.stat-block {\n  display: grid;\n  gap: clamp(24px, 4vw, 56px);\n}\n\n.stat-block-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.strip-stats .stat-eyebrow {\n  display: block;\n  margin-bottom: 10px;\n  font-size: 0.74rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.strip-stats .stat-value {\n  color: #fff;\n  font-variant-numeric: tabular-nums;\n}\n\n.strip-stats .stat-label {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.stat-value {\n  display: block;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  font-size: clamp(2.2rem, 4.5vw, 3.4rem);\n  line-height: 1;\n  color: var(--accent);\n}\n\n.stat-label {\n  display: block;\n  margin-top: 12px;\n  font-size: 0.96rem;\n  line-height: 1.45;\n  color: var(--muted);\n}\n\n/* ---------- Cards / grids ---------- */\n\n.card-grid {\n  display: grid;\n  gap: clamp(18px, 2.4vw, 28px);\n}\n\n.card-grid-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.card-grid-4 {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n.teaser-card,\n.principle-card,\n.role-card {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  padding: clamp(22px, 2.6vw, 32px);\n}\n\n.teaser-card {\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  overflow: hidden;\n  text-decoration: none;\n  color: var(--ink);\n  transition: transform 200ms ease, box-shadow 200ms ease,\n    border-color 200ms ease;\n}\n\n.teaser-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 18px 40px rgba(24, 20, 13, 0.1);\n  border-color: var(--line-strong);\n}\n\n.teaser-media {\n  position: relative;\n  aspect-ratio: 16 / 10;\n  overflow: hidden;\n}\n\n.teaser-media img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  transition: transform 400ms ease;\n}\n\n.teaser-card:hover .teaser-media img {\n  transform: scale(1.04);\n}\n\n.teaser-media .status-pill {\n  position: absolute;\n  top: 14px;\n  left: 14px;\n  background: rgba(20, 16, 9, 0.7);\n  color: #fff;\n  backdrop-filter: blur(4px);\n}\n\n.teaser-content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex: 1;\n  padding: clamp(20px, 2.4vw, 28px);\n}\n\n.teaser-label {\n  font-size: 0.76rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--accent);\n}\n\n.teaser-card h3,\n.principle-card h3,\n.role-card h3 {\n  margin: 0;\n  font-size: 1.3rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n\n.teaser-card p,\n.principle-card p,\n.role-card p {\n  margin: 0;\n  font-size: 1rem;\n  color: var(--muted);\n}\n\n.teaser-link {\n  margin-top: auto;\n  padding-top: 6px;\n  font-weight: 700;\n  font-size: 0.95rem;\n  color: var(--accent);\n}\n\n.principle-card {\n  background: transparent;\n  border: none;\n  border-top: 2px solid var(--ink);\n  border-radius: 0;\n  padding: 24px 0 0;\n}\n\n.role-card {\n  background: transparent;\n  border: none;\n  border-top: 2px solid var(--ink);\n  border-radius: 0;\n  padding: 22px 0 0;\n}\n\n.role-focus {\n  display: block;\n  font-weight: 700;\n  font-size: 0.78rem;\n  line-height: 1.2;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--accent);\n  margin-bottom: 14px;\n}\n\n/* ---------- Status pills / tags ---------- */\n\n.status-pill {\n  display: inline-block;\n  padding: 5px 13px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  border-radius: 0;\n}\n\n.status-ongoing,\n.status-upcoming {\n  background: rgba(244, 71, 0, 0.14);\n  color: var(--accent);\n}\n\n.status-delivered,\n.status-past {\n  background: rgba(24, 20, 13, 0.1);\n  color: var(--ink);\n}\n\n.tag-list {\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 14px 0 0;\n  padding: 0;\n}\n\n.tag {\n  padding: 4px 12px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  border: 1px solid var(--line);\n  border-radius: 0;\n  color: var(--muted);\n}\n\n/* ---------- Case studies ---------- */\n\n.case-list {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: clamp(20px, 2.5vw, 32px);\n}\n\n@media (max-width: 820px) {\n  .case-list {\n    grid-template-columns: 1fr;\n  }\n}\n\n.case-card {\n  scroll-margin-top: 110px;\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.case-cover {\n  position: relative;\n  aspect-ratio: 4 / 3;\n  overflow: hidden;\n}\n\n.case-brand {\n  position: absolute;\n  left: clamp(16px, 2vw, 22px);\n  bottom: clamp(16px, 2vw, 22px);\n  background: var(--ink);\n  color: #fff;\n  padding: 9px 18px;\n  font-size: 0.95rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.case-cover img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  transition: transform 0.5s ease;\n}\n\n.case-card:hover .case-cover img {\n  transform: scale(1.03);\n}\n\n.case-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding: clamp(24px, 3vw, 38px);\n}\n\n.case-title-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.case-title {\n  font-size: clamp(1.5rem, 2.6vw, 2.1rem);\n  line-height: 1.1;\n}\n\n.case-summary {\n  margin: 16px 0 0;\n  font-size: clamp(1.02rem, 1.3vw, 1.18rem);\n  font-weight: 600;\n}\n\n.case-details {\n  margin-top: 16px;\n}\n\n.case-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-weight: 700;\n  font-size: 0.95rem;\n  color: var(--accent);\n  list-style: none;\n}\n\n.case-toggle::-webkit-details-marker {\n  display: none;\n}\n\n.case-toggle::after {\n  content: \"+\";\n  font-size: 1.2em;\n  line-height: 1;\n}\n\n.case-details[open] .case-toggle::after {\n  content: \"–\";\n}\n\n.case-toggle-less {\n  display: none;\n}\n\n.case-details[open] .case-toggle-more {\n  display: none;\n}\n\n.case-details[open] .case-toggle-less {\n  display: inline;\n}\n\n.case-body {\n  margin-top: 14px;\n  display: grid;\n  gap: 12px;\n  color: var(--muted);\n}\n\n.case-body p {\n  margin: 0;\n}\n\n/* Tags pinned to the bottom of the card so they line up across a row. */\n.case-tags {\n  margin-top: auto;\n  padding-top: clamp(20px, 3vw, 28px);\n}\n\n.case-card .stat-block {\n  grid-template-columns: repeat(4, 1fr);\n  margin-top: clamp(26px, 3vw, 38px);\n  padding-top: clamp(24px, 3vw, 34px);\n  border-top: 1px solid var(--line);\n}\n\n.case-footnote {\n  margin: 22px 0 0;\n  font-size: 0.92rem;\n  color: var(--muted);\n}\n\n/* ---------- Layer stack ---------- */\n\n.layer-stack {\n  display: grid;\n  gap: 12px;\n}\n\n.layer {\n  border-radius: var(--radius);\n  padding: clamp(20px, 2.6vw, 30px);\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: clamp(18px, 2.5vw, 30px);\n}\n\n.layer-text {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.layer-icon {\n  flex: none;\n  width: clamp(34px, 4vw, 46px);\n  height: clamp(34px, 4vw, 46px);\n  color: var(--ink);\n  opacity: 0.55;\n}\n\n.layer-3 .layer-icon {\n  color: #f6efd6;\n  opacity: 0.75;\n}\n\n.layer-0 {\n  background: #f2802f;\n}\n.layer-0 .layer-detail {\n  color: rgba(24, 20, 13, 0.78);\n}\n.layer-1 {\n  background: #e4c4a4;\n}\n.layer-2 {\n  background: #cda27d;\n}\n.layer-3 {\n  background: #6e472a;\n}\n.layer-3 .layer-name {\n  color: #f6efd6;\n}\n.layer-3 .layer-detail {\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.layer-name {\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  font-size: clamp(1.1rem, 2vw, 1.45rem);\n}\n\n.layer-detail {\n  font-size: 0.98rem;\n  color: var(--muted);\n}\n\n/* ---------- Rollout timeline ---------- */\n\n.rollout-track {\n  display: grid;\n  gap: 12px;\n}\n\n.rollout-row {\n  display: block;\n  width: 100%;\n}\n\n.rollout-bar {\n  border-radius: var(--radius);\n  padding: clamp(16px, 2vw, 24px);\n  display: flex;\n  align-items: center;\n  gap: clamp(16px, 2.2vw, 26px);\n}\n\n.rollout-icon {\n  flex: none;\n  width: clamp(30px, 3.4vw, 40px);\n  height: clamp(30px, 3.4vw, 40px);\n  color: var(--ink);\n  opacity: 0.55;\n}\n\n.rollout-text {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.rollout-name {\n  font-weight: 800;\n  color: var(--ink);\n}\n\n.rollout-detail {\n  font-size: 0.95rem;\n  color: var(--muted);\n}\n\n.rollout-now {\n  flex: none;\n  background: var(--ink);\n  color: var(--bg);\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  padding: 3px 9px;\n}\n\n/* Reuse the four-layer palette so the two graphics read as one family. */\n.rollout-0 {\n  background: #f2802f;\n}\n.rollout-1 {\n  background: #e4c4a4;\n}\n.rollout-2 {\n  background: #cda27d;\n}\n.rollout-3 {\n  background: #6e472a;\n}\n.rollout-3 .rollout-name {\n  color: #f6efd6;\n}\n.rollout-3 .rollout-detail {\n  color: rgba(255, 255, 255, 0.72);\n}\n.rollout-3 .rollout-icon {\n  color: #f6efd6;\n  opacity: 0.75;\n}\n\n.rollout-axis {\n  position: relative;\n  margin-top: 16px;\n  padding-top: 12px;\n  border-top: 1px solid var(--line-strong);\n  height: 2.4em;\n}\n\n.rollout-tick {\n  position: absolute;\n  top: 12px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--muted);\n  white-space: nowrap;\n  transform: translateX(-50%);\n}\n\n.rollout-tick::before {\n  content: \"\";\n  position: absolute;\n  top: -13px;\n  left: 50%;\n  width: 1px;\n  height: 8px;\n  background: var(--line-strong);\n}\n\n.rollout-axis .rollout-tick:first-child {\n  transform: translateX(0);\n}\n.rollout-axis .rollout-tick:first-child::before {\n  left: 0;\n}\n.rollout-axis .rollout-tick:last-child {\n  transform: translateX(-100%);\n}\n.rollout-axis .rollout-tick:last-child::before {\n  left: auto;\n  right: 0;\n}\n\n/* On narrow screens the staggered offsets get too cramped — stack full width. */\n@media (max-width: 640px) {\n  .rollout-bar {\n    margin-inline-start: 0 !important;\n  }\n  .rollout-axis {\n    display: none;\n  }\n}\n\n/* ---------- Step list ---------- */\n\n.step-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: clamp(18px, 2.6vw, 30px);\n}\n\n.step {\n  display: flex;\n  gap: 22px;\n  align-items: flex-start;\n}\n\n.step-num {\n  flex: none;\n  width: 48px;\n  height: 48px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(244, 71, 0, 0.12);\n  color: var(--accent);\n  border-radius: 50%;\n  font-weight: 800;\n  font-size: 1.15rem;\n}\n\n.step h3 {\n  margin: 8px 0 6px;\n  font-size: 1.3rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n\n.step p {\n  margin: 0;\n  max-width: 70ch;\n  color: var(--muted);\n}\n\n/* ---------- Events ---------- */\n\n.event-list {\n  display: grid;\n  gap: clamp(22px, 3vw, 40px);\n}\n\n.event-card {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  padding: clamp(26px, 4vw, 52px);\n  scroll-margin-top: 100px;\n}\n\n.event-card-head {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.event-date {\n  font-weight: 700;\n  color: var(--muted);\n}\n\n.event-title {\n  font-size: clamp(1.7rem, 3.6vw, 2.8rem);\n}\n\n.event-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 48px;\n  margin: 22px 0;\n}\n\n.event-meta dt {\n  font-size: 0.74rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--accent);\n}\n\n.event-meta dd {\n  margin: 4px 0 0;\n  font-weight: 600;\n}\n\n.event-description {\n  margin: 0 0 22px;\n  max-width: 72ch;\n  font-size: 1.1rem;\n  color: var(--muted);\n}\n\n.event-highlights {\n  list-style: none;\n  margin: 0 0 26px;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 18px;\n}\n\n.event-highlights li {\n  border-top: 2px solid var(--ink);\n  padding: 14px 0 0;\n}\n\n.event-highlights h3 {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 800;\n}\n\n.event-highlights p {\n  margin: 6px 0 0;\n  font-size: 0.96rem;\n  color: var(--muted);\n}\n\n.event-gallery {\n  margin-top: 10px;\n}\n\n/* ---------- Image marquee (behind the scenes) ---------- */\n\n.marquee {\n  width: 100%;\n  overflow: hidden;\n  -webkit-mask-image: linear-gradient(\n    90deg,\n    transparent 0,\n    #000 8%,\n    #000 92%,\n    transparent 100%\n  );\n  mask-image: linear-gradient(\n    90deg,\n    transparent 0,\n    #000 8%,\n    #000 92%,\n    transparent 100%\n  );\n}\n\n.marquee-track {\n  display: flex;\n  width: max-content;\n  animation: marquee-scroll 70s linear infinite;\n}\n\n.marquee-track.is-reverse {\n  animation-direction: reverse;\n}\n\n.marquee:hover .marquee-track {\n  animation-play-state: paused;\n}\n\n.marquee-item {\n  flex: none;\n  height: clamp(190px, 24vw, 300px);\n  margin-right: 16px;\n}\n\n.marquee-item img {\n  height: 100%;\n  width: auto;\n  display: block;\n  object-fit: cover;\n  border-radius: 0;\n}\n\n@keyframes marquee-scroll {\n  from {\n    transform: translateX(0);\n  }\n  to {\n    transform: translateX(-50%);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .marquee-track {\n    animation: none;\n  }\n  .marquee {\n    overflow-x: auto;\n  }\n}\n\n/* ---------- Gallery + lightbox ---------- */\n\n.gallery-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));\n  gap: 12px;\n}\n\n.gallery-card {\n  margin: 0;\n  overflow: hidden;\n  border-radius: 0;\n  aspect-ratio: 4 / 3;\n}\n\n.gallery-button {\n  display: block;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: zoom-in;\n}\n\n.gallery-photo {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n  transition: transform 360ms ease;\n}\n\n.gallery-card:hover .gallery-photo {\n  transform: scale(1.05);\n}\n\n.lightbox {\n  position: fixed;\n  inset: 0;\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: clamp(12px, 3vw, 36px);\n  background: rgba(0, 0, 0, 0.86);\n}\n\n.lightbox-content {\n  position: relative;\n  width: min(96vw, 1200px);\n  max-height: 92vh;\n}\n\n.lightbox-image {\n  display: block;\n  width: 100%;\n  max-height: 92vh;\n  object-fit: contain;\n  border-radius: 0;\n}\n\n.lightbox-close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 42px;\n  height: 42px;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  font-size: 1.3rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.lightbox-nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 46px;\n  height: 46px;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  font-size: 1.3rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.lightbox-nav-prev {\n  left: 12px;\n}\n\n.lightbox-nav-next {\n  right: 12px;\n}\n\n/* ---------- Wizard ---------- */\n\n.wizard-wrap {\n  max-width: 780px;\n}\n\n.wizard {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  padding: clamp(28px, 4vw, 52px);\n}\n\n.wizard-progress {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 20px;\n}\n\n.wizard-dot {\n  width: 100%;\n  height: 6px;\n  border-radius: 0;\n  background: rgba(24, 20, 13, 0.12);\n}\n\n.wizard-dot.is-filled {\n  background: var(--accent);\n}\n\n.wizard-step-label {\n  margin: 0 0 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  font-size: 0.78rem;\n  color: var(--accent);\n}\n\n.wizard-question {\n  margin: 0 0 26px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  font-size: clamp(1.5rem, 3vw, 2.3rem);\n  line-height: 1.08;\n}\n\n.wizard-options {\n  display: grid;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.wizard-option {\n  text-align: left;\n  padding: 1.1rem 1.3rem;\n  background: var(--bg);\n  border: 1px solid var(--line);\n  border-radius: 0;\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-color 140ms ease, background 140ms ease,\n    transform 140ms ease;\n}\n\n.wizard-option:hover,\n.wizard-option.is-selected {\n  background: rgba(244, 71, 0, 0.08);\n  border-color: var(--accent);\n  transform: translateX(4px);\n}\n\n.wizard-headline {\n  font-size: clamp(1.9rem, 4vw, 2.9rem);\n  margin: 8px 0 18px;\n}\n\n.wizard-body {\n  font-size: 1.12rem;\n  margin: 0 0 26px;\n  color: var(--muted);\n}\n\n.wizard-related {\n  border-top: 1px solid var(--line);\n  padding-top: 22px;\n  margin-bottom: 28px;\n}\n\n.wizard-related-title {\n  display: block;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  font-size: 0.78rem;\n  color: var(--accent);\n  margin-bottom: 12px;\n}\n\n.wizard-related ul {\n  margin: 0;\n  padding-left: 18px;\n  display: grid;\n  gap: 10px;\n  color: var(--muted);\n}\n\n.wizard-related a {\n  font-weight: 700;\n  color: var(--ink);\n}\n\n.wizard-actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n/* ---------- Resources / gate ---------- */\n\n.split-layout {\n  display: grid;\n  grid-template-columns: 1.2fr 0.8fr;\n  gap: clamp(32px, 5vw, 72px);\n  align-items: start;\n}\n\n.check-list {\n  list-style: none;\n  margin: 22px 0 0;\n  padding: 0;\n  display: grid;\n  gap: 16px;\n}\n\n.check-list li {\n  position: relative;\n  padding-left: 38px;\n  font-size: 1.08rem;\n}\n\n.check-list li::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 3px;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: rgba(244, 71, 0, 0.14);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23f44700' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.gate-card {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  padding: clamp(26px, 3vw, 36px);\n  position: sticky;\n  top: 110px;\n}\n\n.gate-card h2 {\n  margin: 0 0 8px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  font-size: 1.5rem;\n}\n\n.gate-success h3 {\n  font-weight: 800;\n  margin: 6px 0 18px;\n}\n\n.gate-fallback,\n.gate-success {\n  display: grid;\n  gap: 16px;\n  justify-items: flex-start;\n}\n\n/* ---------- Contact ---------- */\n\n.contact-section {\n  padding-top: clamp(56px, 9vw, 120px);\n}\n\n.contact-layout {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: clamp(28px, 5vw, 48px);\n  align-items: start;\n  max-width: 780px;\n  margin-inline: auto;\n}\n\n.contact-intro .page-title {\n  margin-top: 8px;\n}\n\n.quote-card {\n  margin: clamp(28px, 4vw, 40px) 0;\n  background: var(--dark);\n  color: var(--bg);\n  border-radius: var(--radius);\n  padding: clamp(26px, 3vw, 38px);\n}\n\n.quote-card blockquote {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 500;\n  line-height: 1.55;\n}\n\n.quote-card figcaption {\n  margin-top: 18px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-size: 0.82rem;\n  color: var(--accent-2);\n}\n\n.contact-direct {\n  display: grid;\n  gap: 10px;\n}\n\n.contact-direct a {\n  font-weight: 700;\n  color: var(--ink);\n  text-decoration: none;\n  border-bottom: 2px solid var(--accent);\n  width: fit-content;\n  padding-bottom: 2px;\n}\n\n.contact-form-panel {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  padding: clamp(26px, 3.5vw, 44px);\n}\n\n.contact-block + .contact-block {\n  margin-top: clamp(28px, 4vw, 44px);\n  padding-top: clamp(28px, 4vw, 44px);\n  border-top: 1px solid var(--line);\n}\n\n.contact-block-title {\n  margin: 0 0 6px;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--ink);\n}\n\n.contact-block-lead {\n  margin: 0 0 16px;\n  color: var(--muted);\n}\n\n.booking-confirmed {\n  max-width: 640px;\n  margin-inline: auto;\n  text-align: center;\n}\n\n.booking-confirmed .hero-cta-row {\n  justify-content: center;\n}\n\n.booking-confirmed-note {\n  margin-top: clamp(28px, 4vw, 40px);\n  color: var(--muted);\n  font-size: 0.95rem;\n}\n\n.booking-confirmed-note a {\n  font-weight: 700;\n  color: var(--ink);\n  border-bottom: 2px solid var(--accent);\n  text-decoration: none;\n}\n\n/* ---------- Scheduler & contact CTA ---------- */\n\n.registration-form-shell,\n.registration-fallback {\n  margin-top: 4px;\n}\n\n.registration-fallback {\n  display: grid;\n  gap: 14px;\n  justify-items: flex-start;\n}\n\n/* ---------- HubSpot form (step 1 of the contact flow) ---------- */\n/* The form renders inside a HubSpot-hosted iframe, so its fields are styled in\n   the HubSpot form editor — only the wrapper is ours to control here. */\n\n.hubspot-form-target {\n  min-height: 120px;\n}\n\n.hubspot-form-target iframe {\n  display: block;\n  width: 100%;\n  border: 0;\n}\n\n/* ---------- CTA band ---------- */\n\n.cta-band {\n  padding: clamp(20px, 4vw, 40px) 0 clamp(64px, 9vw, 130px);\n}\n\n.cta-band-inner {\n  background: var(--dark);\n  color: var(--bg);\n  border-radius: 0;\n  padding: clamp(36px, 5vw, 72px);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 28px;\n}\n\n.cta-band h2 {\n  margin: 0 0 10px;\n  font-size: clamp(1.7rem, 3.4vw, 2.7rem);\n  color: var(--bg);\n}\n\n.cta-band p {\n  margin: 0;\n  max-width: 52ch;\n  color: rgba(255, 255, 255, 0.72);\n}\n\n/* ---------- Empty state ---------- */\n\n.empty-state {\n  border: 1px dashed var(--line-strong);\n  border-radius: var(--radius);\n  padding: clamp(26px, 4vw, 44px);\n  background: var(--bg-soft);\n  font-size: 1.08rem;\n  color: var(--muted);\n}\n\n.empty-state p {\n  margin: 0;\n}\n\n/* ---------- Footer ---------- */\n\n.site-footer {\n  background: var(--dark);\n  color: var(--bg);\n  margin-top: auto;\n}\n\n.site-footer-inner {\n  max-width: var(--container);\n  margin: 0 auto;\n  padding: clamp(48px, 6vw, 84px) clamp(20px, 5vw, 48px);\n  display: grid;\n  grid-template-columns: 1.2fr 1fr;\n  gap: clamp(32px, 5vw, 72px);\n}\n\n.footer-kicker {\n  margin: 0 0 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: var(--accent-2);\n  font-size: 0.95rem;\n}\n\n.footer-tag {\n  margin: 0;\n  max-width: 46ch;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.footer-cols {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 28px;\n}\n\n.footer-col {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.footer-contact-person {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.footer-phone {\n  color: var(--accent-2);\n}\n\n.footer-col-title {\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-size: 0.78rem;\n  color: var(--accent-2);\n}\n\n.footer-link {\n  color: rgba(255, 255, 255, 0.78);\n  text-decoration: none;\n  font-size: 0.96rem;\n}\n\n.footer-link:hover {\n  color: #fff;\n}\n\n.footer-base {\n  max-width: var(--container);\n  margin: 0 auto;\n  padding: 22px clamp(20px, 5vw, 48px);\n  border-top: 1px solid rgba(255, 255, 255, 0.14);\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 0.82rem;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.footer-base-link {\n  color: rgba(255, 255, 255, 0.5);\n  text-decoration: none;\n}\n\n.footer-base-link:hover {\n  color: #fff;\n}\n\n/* ---------- Legal / long-form content ---------- */\n\n.legal-content {\n  max-width: 760px;\n}\n\n.legal-updated {\n  margin: 0 0 clamp(24px, 4vw, 36px);\n  font-size: 0.9rem;\n  color: var(--muted);\n}\n\n.legal-content h2 {\n  margin: clamp(32px, 4vw, 44px) 0 12px;\n  font-size: clamp(1.3rem, 2.2vw, 1.6rem);\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n\n.legal-content p,\n.legal-content li {\n  color: var(--ink);\n  line-height: 1.7;\n}\n\n.legal-content ul {\n  margin: 0 0 4px;\n  padding-left: 22px;\n  display: grid;\n  gap: 8px;\n}\n\n.legal-content a {\n  font-weight: 600;\n  color: var(--ink);\n  text-decoration: underline;\n  text-decoration-color: var(--accent);\n  text-underline-offset: 2px;\n}\n\n/* ---------- Animations ---------- */\n\n@keyframes rise-up {\n  from {\n    opacity: 0;\n    transform: translateY(18px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.hero-copy,\n.page-hero > .container {\n  animation: rise-up 650ms cubic-bezier(0.2, 0.75, 0.3, 1) both;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html {\n    scroll-behavior: auto;\n  }\n  .hero-copy,\n  .page-hero > .container {\n    animation: none;\n  }\n}\n\n/* ---------- Responsive ---------- */\n\n@media (max-width: 1000px) {\n  .nav-toggle {\n    display: block;\n  }\n\n  .site-nav {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0;\n    background: var(--bg);\n    border-bottom: 1px solid var(--line);\n    padding: 8px clamp(20px, 5vw, 48px) 20px;\n    display: none;\n  }\n\n  .site-nav.is-open {\n    display: flex;\n  }\n\n  .site-nav-link {\n    padding: 14px 0;\n    border-bottom: 1px solid var(--line);\n    opacity: 1;\n  }\n\n  .nav-cta {\n    margin-top: 14px;\n    justify-content: center;\n  }\n\n  .hero-inner {\n    grid-template-columns: 1fr;\n    padding-right: clamp(20px, 5vw, 48px);\n    min-height: 0;\n    gap: 0;\n  }\n\n  .hero-copy {\n    max-width: none;\n    padding: clamp(40px, 8vw, 72px) 0 clamp(28px, 5vw, 40px);\n  }\n\n  /* Drop the badge into normal flow on mobile so it sits below the buttons\n     instead of overlapping them. */\n  .hero-partner-badge {\n    position: static;\n    height: clamp(88px, 24vw, 124px);\n    margin: 0 0 clamp(36px, 8vw, 56px);\n  }\n\n  /* The image stays a full background on mobile too; darken it more evenly so\n     the white text reads over the whole column. */\n  .hero-visual::after {\n    background: linear-gradient(\n      180deg,\n      rgba(10, 8, 4, 0.7) 0%,\n      rgba(10, 8, 4, 0.78) 100%\n    );\n  }\n\n  .card-grid-3,\n  .card-grid-4,\n  .stat-block-3 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .split-layout,\n  .contact-layout,\n  .site-footer-inner {\n    grid-template-columns: 1fr;\n  }\n\n  .gate-card {\n    position: static;\n  }\n\n  .case-card .stat-block {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .event-highlights {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 560px) {\n  .site-brand-partner {\n    padding-left: 10px;\n    font-size: 0.66rem;\n    letter-spacing: 0.06em;\n  }\n\n  .card-grid-3,\n  .card-grid-4,\n  .stat-block-3,\n  .case-card .stat-block {\n    grid-template-columns: 1fr;\n  }\n\n  .hero-cta-row .cta-button,\n  .cta-band .cta-button {\n    width: 100%;\n  }\n\n  .gallery-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .cta-band-inner {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .contact-form-panel {\n    padding: 20px 16px;\n  }\n\n  /* Stack the form fields into a single column on small screens. */\n  .hubspot-form-target :is(form, .hs-form) {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
